/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/api.js"
/*!******************************!*\
  !*** ./js/components/api.js ***!
  \******************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fetchAllCollectionProductsFromTemplate: () => (/* binding */ fetchAllCollectionProductsFromTemplate),
/* harmony export */   fetchCollectionProducts: () => (/* binding */ fetchCollectionProducts),
/* harmony export */   fetchProductSetupData: () => (/* binding */ fetchProductSetupData),
/* harmony export */   parseDiscountPercentage: () => (/* binding */ parseDiscountPercentage)
/* harmony export */ });
/* unused harmony exports normalizeStorefrontProduct, normalizeStorefrontProducts */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _storefront_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./storefront.js */ "./js/components/storefront.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_2__);




/**
 * Parse discount percentage from custom.discount metafield (value.percentage.value).
 * API may return value as JSON string or (if pre-parsed) object.
 * @param {string|object|null|undefined} discountMetafieldValue - metafield value
 * @returns {number} 0 if missing or invalid
 */
function parseDiscountPercentage(discountMetafieldValue) {
  var _obj;
  if (discountMetafieldValue == null) return 0;
  var obj = discountMetafieldValue;
  if (typeof discountMetafieldValue === 'string') {
    try {
      obj = JSON.parse(discountMetafieldValue);
    } catch (_unused) {
      return 0;
    }
  }
  var value = (_obj = obj) === null || _obj === void 0 || (_obj = _obj.percentage) === null || _obj === void 0 ? void 0 : _obj.value;
  var n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Normalizes a Storefront API product response to match ProductCard.js expected format
 * @param {Object} storefrontProduct - Product from Storefront API
 * @returns {Object} Normalized product matching ProductCard format
 */
function normalizeStorefrontProduct(storefrontProduct) {
  var _priceRange$minVarian, _priceRange$maxVarian, _metafieldsMap$custom, _storefrontProduct$va;
  // Extract numeric ID from GID format (e.g., "gid://shopify/Product/8704959348903" -> 8704959348903)
  var extractNumericId = gid => {
    if (!gid) return null;
    var match = gid.match(/\/(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  };

  // Convert price string to cents (number)
  // Storefront API returns amount as string in cents (e.g., "10434.0" = 10434 cents)
  var priceToCents = priceString => {
    if (!priceString) return 0;
    var cents = parseFloat(priceString) * 100;
    return isNaN(cents) ? 0 : cents;
  };
  var productId = extractNumericId(storefrontProduct.id);
  var priceRange = storefrontProduct.priceRange || {};
  var minPriceCents = priceToCents((_priceRange$minVarian = priceRange.minVariantPrice) === null || _priceRange$minVarian === void 0 ? void 0 : _priceRange$minVarian.amount);
  var maxPriceCents = priceToCents((_priceRange$maxVarian = priceRange.maxVariantPrice) === null || _priceRange$maxVarian === void 0 ? void 0 : _priceRange$maxVarian.amount);
  var featuredImage = storefrontProduct.featuredImage;

  // Build images array matching expected format
  var images = [];
  if (featuredImage !== null && featuredImage !== void 0 && featuredImage.url) {
    images.push({
      width: "1920",
      height: "1080",
      url: featuredImage.url,
      alt: featuredImage.altText || storefrontProduct.title || "",
      aspectRatio: 1
    });
  }

  // Extract metafields and build nested structure
  var metafields = storefrontProduct.metafields || [];
  var metafieldsMap = {};
  metafields.forEach(metafield => {
    var key = metafield === null || metafield === void 0 ? void 0 : metafield.key;
    var namespace = metafield === null || metafield === void 0 ? void 0 : metafield.namespace;
    if (namespace && key) {
      if (!metafieldsMap[namespace]) {
        metafieldsMap[namespace] = {};
      }
      metafieldsMap[namespace][key] = metafield.value;
    }
  });

  // Applicable price from custom.discount (value.percentage.value) (same logic as price.liquid / product-json.liquid)
  var discountPercentage = parseDiscountPercentage((_metafieldsMap$custom = metafieldsMap.custom) === null || _metafieldsMap$custom === void 0 ? void 0 : _metafieldsMap$custom.discount) || 0;
  var useApplicablePrice = discountPercentage > 0;

  // Build variants array - prices in cents (matching provided example format)
  var variants = [];
  if ((_storefrontProduct$va = storefrontProduct.variants) !== null && _storefrontProduct$va !== void 0 && _storefrontProduct$va.edges && storefrontProduct.variants.edges.length > 0) {
    storefrontProduct.variants.edges.forEach(variantEdge => {
      var _variant$price, _variant$compareAtPri, _metafieldsMap$custom2;
      var variant = variantEdge.node;
      var variantId = extractNumericId(variant.id);
      var variantPriceCents = priceToCents((_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.amount);
      var variantCompareAtPriceCents = priceToCents((_variant$compareAtPri = variant.compareAtPrice) === null || _variant$compareAtPri === void 0 ? void 0 : _variant$compareAtPri.amount);
      var finalPrice, finalCompareAtPrice;
      if (useApplicablePrice) {
        var discountDecimal = discountPercentage / 100;
        var discountAmount = variantPriceCents * discountDecimal;
        finalPrice = Math.round(variantPriceCents - discountAmount);
        finalCompareAtPrice = variantPriceCents;
      } else {
        finalPrice = variantPriceCents;
        finalCompareAtPrice = variantCompareAtPriceCents;
      }

      // SKU from variant or metafield
      var sku = variant.sku || ((_metafieldsMap$custom2 = metafieldsMap.custom) === null || _metafieldsMap$custom2 === void 0 ? void 0 : _metafieldsMap$custom2.spec_model_number) || null;
      variants.push({
        id: variantId,
        price: finalPrice,
        compareAtPrice: finalCompareAtPrice,
        available: variant.availableForSale !== false,
        sku: sku
      });
    });
  } else {
    var _metafieldsMap$custom3;
    // Fallback: create minimal variant if no variants in response
    var finalPrice, finalCompareAtPrice;
    if (useApplicablePrice) {
      var discountDecimal = discountPercentage / 100;
      var discountAmount = minPriceCents * discountDecimal;
      finalPrice = Math.round(minPriceCents - discountAmount);
      finalCompareAtPrice = minPriceCents;
    } else {
      finalPrice = minPriceCents;
      finalCompareAtPrice = 0;
    }
    var fallbackSku = ((_metafieldsMap$custom3 = metafieldsMap.custom) === null || _metafieldsMap$custom3 === void 0 ? void 0 : _metafieldsMap$custom3.spec_model_number) || null;
    variants.push({
      id: productId,
      price: finalPrice,
      compareAtPrice: finalCompareAtPrice,
      available: storefrontProduct.availableForSale !== false,
      sku: fallbackSku
    });
  }
  return {
    id: productId,
    handle: storefrontProduct.handle || "",
    title: storefrontProduct.title || "",
    url: "/products/".concat(storefrontProduct.handle || ""),
    vendor: storefrontProduct.vendor || "",
    productType: storefrontProduct.productType || "",
    tags: storefrontProduct.tags || [],
    templateSuffix: storefrontProduct.templateSuffix || null,
    available: storefrontProduct.availableForSale !== false,
    priceRange: {
      min: minPriceCents,
      max: maxPriceCents || minPriceCents
    },
    images: images,
    variants: variants,
    metafields: metafieldsMap,
    hasApplicablePrice: useApplicablePrice
  };
}

/**
 * Normalizes an array of Storefront API products
 * @param {Array} storefrontProducts - Array of products from Storefront API
 * @returns {Array} Array of normalized products
 */
function normalizeStorefrontProducts(storefrontProducts) {
  if (!Array.isArray(storefrontProducts)) {
    return [];
  }
  return storefrontProducts.map(normalizeStorefrontProduct);
}
function fetchProductSetupData(_x) {
  return _fetchProductSetupData.apply(this, arguments);
}
function _fetchProductSetupData() {
  _fetchProductSetupData = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (handle) {
    var url = "".concat(window.Shopify.routes.root, "products/").concat(handle, "?view=setup");
    if (!url) {
      throw new Error("Product setup URL not found");
    }
    try {
      var response = yield fetch(url, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error("Failed to fetch product data: ".concat(response.status));
      }
      return yield json_6__WEBPACK_IMPORTED_MODULE_2___default().parse(yield response.text());
    } catch (error) {
      console.error("Error fetching product setup data:", error);
      throw error;
    }
  });
  return _fetchProductSetupData.apply(this, arguments);
}
function fetchCollectionProducts(_x2) {
  return _fetchCollectionProducts.apply(this, arguments);
}

/**
 * Fetches all products from a collection using the Liquid template endpoint
 * Makes requests in batches of 5 to avoid overwhelming the server
 * @param {Object} config - Configuration object
 * @param {string} config.collectionHandle - Collection handle
 * @param {number} config.productsCount - Total number of products in collection
 * @param {number} config.perPage - Items per page (default: 20, max: 250)
 * @returns {Promise<Array>} Array of all products
 */
function _fetchCollectionProducts() {
  _fetchCollectionProducts = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    var apiClient = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.createStorefrontApiClient)();
    var {
      collectionHandle,
      filters = [],
      first = 24,
      after = null,
      metafieldIdentifiers = [],
      sortKey = 'BEST_SELLING',
      reverse = false
    } = config;
    if (!collectionHandle) {
      throw new Error("collectionHandle is required");
    }
    var productFilters = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.buildProductFilter)(filters);

    // Applicable price is derived from custom.discount (value.percentage.value) (same as price.liquid / product-json.liquid)
    var discountMetafield = {
      namespace: "custom",
      key: "discount"
    };
    var customSpecModelNumberMetafield = {
      namespace: "custom",
      key: "spec_model_number"
    };
    var addOnsMetafield = {
      namespace: "custom",
      key: "add_ons"
    };
    var mandatoryProductsMetafield = {
      namespace: "custom",
      key: "mandatory_products"
    };
    var surchargeCaliforniaMetafield = {
      namespace: "custom",
      key: "surcharge_for_california_in_percentage"
    };
    var metafieldsFragment = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.buildMetafieldsFragment)([...metafieldIdentifiers, discountMetafield, customSpecModelNumberMetafield, addOnsMetafield, mandatoryProductsMetafield, surchargeCaliforniaMetafield]);
    var query = (0,_storefront_js__WEBPACK_IMPORTED_MODULE_1__.buildGraphQLQuery)("CollectionProducts", {
      handle: "String!",
      first: "Int",
      after: "String",
      filters: "[ProductFilter!]",
      sortKey: "ProductCollectionSortKeys",
      reverse: "Boolean"
    }, "collection(handle: $handle) {\n      products(first: $first, after: $after, filters: $filters, sortKey: $sortKey, reverse: $reverse) {\n        filters {\n          id\n          label\n          type\n          values {\n            id\n            label\n            count\n            input\n          }\n        }\n        edges {\n          node {\n            id\n            handle\n            title\n            vendor\n            productType\n            tags\n            availableForSale\n            priceRange {\n              minVariantPrice {\n                amount\n                currencyCode\n              }\n              maxVariantPrice {\n                amount\n                currencyCode\n              }\n            }\n            featuredImage {\n              url\n              altText\n            }\n            variants(first: 250) {\n              edges {\n                node {\n                  id\n                  price {\n                    amount\n                    currencyCode\n                  }\n                  compareAtPrice {\n                    amount\n                    currencyCode\n                  }\n                  availableForSale\n                  sku\n                }\n              }\n            }\n            ".concat(metafieldsFragment, "\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }"));
    try {
      var response = yield apiClient.post("", {
        query,
        variables: {
          handle: collectionHandle,
          first,
          after,
          filters: productFilters.length > 0 ? productFilters : null,
          sortKey,
          reverse
        }
      });
      if (response.data.errors) {
        throw new Error("GraphQL errors: ".concat(response.data.errors.map(e => e.message).join(", ")));
      }
      var rawProducts = response.data.data.collection.products.edges.map(edge => edge.node);
      var normalizedProducts = normalizeStorefrontProducts(rawProducts);
      var _filters = response.data.data.collection.products.filters || [];
      return {
        products: normalizedProducts,
        pageInfo: response.data.data.collection.products.pageInfo,
        filters: _filters
      };
    } catch (error) {
      console.error("Error fetching collection products:", error);
      throw error;
    }
  });
  return _fetchCollectionProducts.apply(this, arguments);
}
function fetchAllCollectionProductsFromTemplate(_x3) {
  return _fetchAllCollectionProductsFromTemplate.apply(this, arguments);
}
function _fetchAllCollectionProductsFromTemplate() {
  _fetchAllCollectionProductsFromTemplate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (config) {
    var {
      collectionHandle,
      productsCount
    } = config;
    if (!collectionHandle) {
      throw new Error("collectionHandle is required");
    }
    if (!productsCount || productsCount === 0) {
      return [];
    }
    var itemsPerPage = 250;
    var totalPages = Math.ceil(productsCount / itemsPerPage);
    var parallelBatchSize = 15; // Number of parallel requests per batch
    var allProducts = [];
    try {
      // Create array of page numbers to fetch
      var pagesToFetch = Array.from({
        length: totalPages
      }, (_, i) => i + 1);

      // Process pages in batches
      while (pagesToFetch.length > 0) {
        // Take a batch of pages to process in parallel
        var batch = pagesToFetch.splice(0, parallelBatchSize);

        // Make parallel requests for this batch
        var batchResults = yield Promise.all(batch.map(page => {
          var url = "".concat(window.Shopify.routes.root, "collections/").concat(collectionHandle, "?view=products-paginated&page=").concat(page);
          return fetch(url, {
            method: "GET"
          }).then(response => {
            if (!response.ok) {
              throw new Error("Failed to fetch page ".concat(page, ": ").concat(response.status));
            }
            return response.json();
          }).then(products => {
            if (!Array.isArray(products)) {
              console.warn("Page ".concat(page, " returned non-array data:"), products);
              return [];
            }
            return products;
          }).catch(error => {
            console.error("Error fetching page ".concat(page, ":"), error);
            return []; // Return empty array on error to continue processing
          });
        }));

        // Collect products from batch results
        batchResults.forEach(products => {
          if (Array.isArray(products)) {
            allProducts.push(...products);
          }
        });
      }
      return allProducts;
    } catch (error) {
      console.error("Error fetching all collection products from template:", error);
      throw error;
    }
  });
  return _fetchAllCollectionProductsFromTemplate.apply(this, arguments);
}

/***/ },

/***/ "./js/components/product-customise.js"
/*!********************************************!*\
  !*** ./js/components/product-customise.js ***!
  \********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   quickAddToCart: () => (/* binding */ quickAddToCart)
/* harmony export */ });
/* unused harmony export customiseProduct */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _react_product_setup_drawer_js_drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./react/product-setup-drawer.js/drawer */ "./js/components/react/product-setup-drawer.js/drawer.js");



/**
 * Get selected variant ID from product form
 */
var getSelectedVariantId = productInfo => {
  var _productInfo$querySel;
  var variantJson = productInfo === null || productInfo === void 0 || (_productInfo$querySel = productInfo.querySelector('variant-selects [data-selected-variant]')) === null || _productInfo$querySel === void 0 ? void 0 : _productInfo$querySel.innerHTML;
  if (!variantJson) return null;
  try {
    var variant = JSON.parse(variantJson);
    return (variant === null || variant === void 0 ? void 0 : variant.id) || null;
  } catch (_unused) {
    return null;
  }
};

/**
 * Get quantity from quantity input
 */
var getQuantity = productInfo => {
  var quantityInput = productInfo === null || productInfo === void 0 ? void 0 : productInfo.querySelector('quantity-input input[name="quantity"]');
  return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
};
var setButtonLoading = (el, loading) => {
  if (!el) return;
  if (loading) {
    el.setAttribute('data-state', 'loading');
    el.setAttribute('aria-busy', 'true');
  } else {
    el.removeAttribute('data-state');
    el.removeAttribute('aria-busy');
  }
};
var getVariantIdFromTrigger = trigger => {
  var _trigger$dataset;
  var raw = trigger === null || trigger === void 0 || (_trigger$dataset = trigger.dataset) === null || _trigger$dataset === void 0 ? void 0 : _trigger$dataset.variantId;
  return raw != null && raw !== '' ? Number(raw) : null;
};
var getProductInfo = trigger => (trigger === null || trigger === void 0 ? void 0 : trigger.closest('product-info')) || document.querySelector('product-info[id^="MainProduct"]');

/**
 * Direct add to cart (single variant) then open cart drawer — normal flow, no configurator
 */
var quickAddToCart = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (trigger) {
    var variantId = getVariantIdFromTrigger(trigger);
    if (!variantId) return;
    setButtonLoading(trigger, true);
    var quantity = parseInt(trigger.dataset.quantity, 10) || 1;
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
      bubbles: true,
      detail: {
        sections: sectionsToBundle
      }
    }));
    try {
      var _window$FoxTheme, _window$FoxTheme$publ, _document$querySelect, _document$querySelect2;
      var response = yield fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity
          }],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      });
      if (!response.ok) {
        var err = yield response.json();
        throw new Error(err.description || 'Failed to add to cart');
      }
      var {
        sections
      } = yield response.json();
      var cartResponse = yield fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      var cartJson = yield cartResponse.json();
      cartJson.sections = sections;
      (_window$FoxTheme = window.FoxTheme) === null || _window$FoxTheme === void 0 || (_window$FoxTheme = _window$FoxTheme.pubsub) === null || _window$FoxTheme === void 0 || (_window$FoxTheme$publ = _window$FoxTheme.publish) === null || _window$FoxTheme$publ === void 0 || _window$FoxTheme$publ.call(_window$FoxTheme, window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: cartJson
      });
      (_document$querySelect = document.querySelector('cart-drawer')) === null || _document$querySelect === void 0 || (_document$querySelect2 = _document$querySelect.show) === null || _document$querySelect2 === void 0 || _document$querySelect2.call(_document$querySelect);
    } catch (e) {
      console.error('Quick add to cart:', e);
    } finally {
      setButtonLoading(trigger, false);
    }
  });
  return function quickAddToCart(_x) {
    return _ref.apply(this, arguments);
  };
}();
var customiseProduct = trigger => {
  var _getVariantIdFromTrig;
  var productInfo = getProductInfo(trigger);
  window.updateDrawerComponent(_react_product_setup_drawer_js_drawer__WEBPACK_IMPORTED_MODULE_1__["default"], {
    handle: trigger.dataset.productHandle,
    selectedVariantId: (_getVariantIdFromTrig = getVariantIdFromTrigger(trigger)) !== null && _getVariantIdFromTrig !== void 0 ? _getVariantIdFromTrig : getSelectedVariantId(productInfo),
    quantity: getQuantity(productInfo)
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (() => {
  document.addEventListener('click', ev => {
    var quickAdd = ev.target.closest('[data-quick-add]');
    if (quickAdd) {
      ev.preventDefault();
      ev.stopPropagation();
      quickAddToCart(quickAdd);
      return;
    }
    var trigger = ev.target.closest('[data-customise-trigger]');
    if (!trigger) return;
    ev.preventDefault();
    ev.stopPropagation();
    setButtonLoading(trigger, true);
    customiseProduct(trigger);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setButtonLoading(trigger, false));
    });
  });
});

/***/ },

/***/ "./js/components/react/collection-product-grid/CollectionProductGrid.js"
/*!******************************************************************************!*\
  !*** ./js/components/react/collection-product-grid/CollectionProductGrid.js ***!
  \******************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CollectionProductGrid)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/dialog/dialog.js");
/* harmony import */ var _filterUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./filterUtils */ "./js/components/react/collection-product-grid/filterUtils.js");
/* harmony import */ var _FilterUI__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./FilterUI */ "./js/components/react/collection-product-grid/FilterUI.js");
/* harmony import */ var _ProductCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ProductCard */ "./js/components/react/collection-product-grid/ProductCard.js");
/* harmony import */ var _CollectionToolbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CollectionToolbar */ "./js/components/react/collection-product-grid/CollectionToolbar.js");
/* harmony import */ var _SortBy__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./SortBy */ "./js/components/react/collection-product-grid/SortBy.js");
/* harmony import */ var _Empty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Empty */ "./js/components/react/collection-product-grid/Empty.js");
/* harmony import */ var JsComponents_api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! JsComponents/api */ "./js/components/api.js");
/* harmony import */ var _paginate__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./paginate */ "./js/components/react/collection-product-grid/paginate.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }












/** Theme-matching icon for close button */
function IconClose(_ref) {
  var {
    size = 'large',
    className = ''
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    focusable: "false",
    className: "icon icon-close icon--".concat(size === 'large' ? 'large' : 'extra-small', " ").concat(className).trim(),
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M18.75 5.13496L5.25 18.8544",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
    d: "M18.75 18.8544L5.25 5.13496",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

/**
 * Initial state shape (from Liquid):
 * - collectionHandle
 * - settings: { container, color_scheme, products_per_page, columns_desktop, ... }
 * - filters: array (per-filter isNonIndexed from collection-filter-metafields when relevant)
 * - products: array (from collection-products-json snippet)
 * indexed = server payload ready (we have products); filter-level isNonIndexed marks filters that are not storefront-indexed.
 */
/** Map Shopify native sort_by values to custom sort constants */
var SHOPIFY_SORT_MAP = {
  'manual': 'COLLECTION_DEFAULT',
  'best-selling': 'BEST_SELLING',
  'price-ascending': 'PRICE_LOW_TO_HIGH',
  'price-descending': 'PRICE_HIGH_TO_LOW',
  'created-ascending': 'CREATED_OLDEST_FIRST',
  'created-descending': 'CREATED_NEWEST_FIRST'
};
function normalizeShopifySortValue(value) {
  var _SHOPIFY_SORT_MAP$val;
  if (!value) return '';
  return (_SHOPIFY_SORT_MAP$val = SHOPIFY_SORT_MAP[value]) !== null && _SHOPIFY_SORT_MAP$val !== void 0 ? _SHOPIFY_SORT_MAP$val : value;
}
function getProps(props) {
  var _props$shopifyData, _data$sort_by, _data$collectionHandl, _data$settings, _data$cardSettings;
  var data = (_props$shopifyData = props.shopifyData) !== null && _props$shopifyData !== void 0 ? _props$shopifyData : props;
  var products = Array.isArray(data.products) ? data.products : [];
  var productsCount = typeof data.products_count === 'number' ? data.products_count : null;
  var allProductsCount = typeof data.all_products_count === 'number' ? data.all_products_count : null;
  var sortOptions = [{
    name: 'Featured',
    value: 'COLLECTION_DEFAULT'
  }, {
    name: 'Best selling',
    value: 'BEST_SELLING'
  }, {
    name: 'Price, low to high',
    value: 'PRICE_LOW_TO_HIGH'
  }, {
    name: 'Price, high to low',
    value: 'PRICE_HIGH_TO_LOW'
  }, {
    name: 'Date, new to old',
    value: 'CREATED_NEWEST_FIRST'
  }, {
    name: 'Date, old to new',
    value: 'CREATED_OLDEST_FIRST'
  }];
  var defaultSortBy = normalizeShopifySortValue((_data$sort_by = data.sort_by) !== null && _data$sort_by !== void 0 ? _data$sort_by : '');
  return {
    collectionHandle: (_data$collectionHandl = data.collectionHandle) !== null && _data$collectionHandl !== void 0 ? _data$collectionHandl : '',
    settings: (_data$settings = data.settings) !== null && _data$settings !== void 0 ? _data$settings : {},
    cardSettings: (_data$cardSettings = data.cardSettings) !== null && _data$cardSettings !== void 0 ? _data$cardSettings : {},
    indexed: Array.isArray(data.products),
    filters: Array.isArray(data.filters) ? data.filters : [],
    products,
    productsCount,
    allProductsCount,
    sortOptions,
    defaultSortBy
  };
}

/** Theme color_scheme can be a string (e.g. "scheme-1") or an object; class names need a string. */
function colorSchemeClass(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scheme-1';
  if (typeof value === 'string' && value) return value;
  if (value && typeof value === 'object' && typeof value.setting_identifier === 'string') return value.setting_identifier;
  return fallback;
}

/** Map sort value to Storefront API sortKey and reverse flag */
function getSortParams(sortBy) {
  var normalized = normalizeShopifySortValue(sortBy);
  switch (normalized) {
    case 'COLLECTION_DEFAULT':
      return {
        sortKey: 'COLLECTION_DEFAULT',
        reverse: false
      };
    case 'BEST_SELLING':
      return {
        sortKey: 'BEST_SELLING',
        reverse: false
      };
    case 'PRICE_HIGH_TO_LOW':
      return {
        sortKey: 'PRICE',
        reverse: true
      };
    case 'PRICE_LOW_TO_HIGH':
      return {
        sortKey: 'PRICE',
        reverse: false
      };
    case 'CREATED_NEWEST_FIRST':
      return {
        sortKey: 'CREATED',
        reverse: true
      };
    case 'CREATED_OLDEST_FIRST':
      return {
        sortKey: 'CREATED',
        reverse: false
      };
    default:
      return {
        sortKey: 'COLLECTION_DEFAULT',
        reverse: false
      };
  }
}

/** Client-side sort products */
function sortProducts(products, sortBy) {
  if (!Array.isArray(products) || products.length === 0) return products;
  var sorted = [...products];
  switch (sortBy) {
    case 'PRICE_LOW_TO_HIGH':
      sorted.sort((a, b) => {
        var _ref2, _a$priceRange$min, _a$priceRange, _a$variants, _ref3, _b$priceRange$min, _b$priceRange, _b$variants;
        var priceA = (_ref2 = (_a$priceRange$min = (_a$priceRange = a.priceRange) === null || _a$priceRange === void 0 ? void 0 : _a$priceRange.min) !== null && _a$priceRange$min !== void 0 ? _a$priceRange$min : (_a$variants = a.variants) === null || _a$variants === void 0 || (_a$variants = _a$variants[0]) === null || _a$variants === void 0 ? void 0 : _a$variants.price) !== null && _ref2 !== void 0 ? _ref2 : 0;
        var priceB = (_ref3 = (_b$priceRange$min = (_b$priceRange = b.priceRange) === null || _b$priceRange === void 0 ? void 0 : _b$priceRange.min) !== null && _b$priceRange$min !== void 0 ? _b$priceRange$min : (_b$variants = b.variants) === null || _b$variants === void 0 || (_b$variants = _b$variants[0]) === null || _b$variants === void 0 ? void 0 : _b$variants.price) !== null && _ref3 !== void 0 ? _ref3 : 0;
        return Number(priceA) - Number(priceB);
      });
      break;
    case 'PRICE_HIGH_TO_LOW':
      sorted.sort((a, b) => {
        var _ref4, _ref5, _a$priceRange$max, _a$priceRange2, _a$priceRange3, _a$variants2, _ref6, _ref7, _b$priceRange$max, _b$priceRange2, _b$priceRange3, _b$variants2;
        var priceA = (_ref4 = (_ref5 = (_a$priceRange$max = (_a$priceRange2 = a.priceRange) === null || _a$priceRange2 === void 0 ? void 0 : _a$priceRange2.max) !== null && _a$priceRange$max !== void 0 ? _a$priceRange$max : (_a$priceRange3 = a.priceRange) === null || _a$priceRange3 === void 0 ? void 0 : _a$priceRange3.min) !== null && _ref5 !== void 0 ? _ref5 : (_a$variants2 = a.variants) === null || _a$variants2 === void 0 || (_a$variants2 = _a$variants2[0]) === null || _a$variants2 === void 0 ? void 0 : _a$variants2.price) !== null && _ref4 !== void 0 ? _ref4 : 0;
        var priceB = (_ref6 = (_ref7 = (_b$priceRange$max = (_b$priceRange2 = b.priceRange) === null || _b$priceRange2 === void 0 ? void 0 : _b$priceRange2.max) !== null && _b$priceRange$max !== void 0 ? _b$priceRange$max : (_b$priceRange3 = b.priceRange) === null || _b$priceRange3 === void 0 ? void 0 : _b$priceRange3.min) !== null && _ref7 !== void 0 ? _ref7 : (_b$variants2 = b.variants) === null || _b$variants2 === void 0 || (_b$variants2 = _b$variants2[0]) === null || _b$variants2 === void 0 ? void 0 : _b$variants2.price) !== null && _ref6 !== void 0 ? _ref6 : 0;
        return Number(priceB) - Number(priceA);
      });
      break;
    case 'CREATED_NEWEST_FIRST':
      sorted.sort((a, b) => {
        var _ref8, _a$createdAt, _ref9, _b$createdAt;
        var dateA = new Date((_ref8 = (_a$createdAt = a.createdAt) !== null && _a$createdAt !== void 0 ? _a$createdAt : a.created_at) !== null && _ref8 !== void 0 ? _ref8 : 0);
        var dateB = new Date((_ref9 = (_b$createdAt = b.createdAt) !== null && _b$createdAt !== void 0 ? _b$createdAt : b.created_at) !== null && _ref9 !== void 0 ? _ref9 : 0);
        return dateB - dateA;
      });
      break;
    case 'CREATED_OLDEST_FIRST':
      sorted.sort((a, b) => {
        var _ref0, _a$createdAt2, _ref1, _b$createdAt2;
        var dateA = new Date((_ref0 = (_a$createdAt2 = a.createdAt) !== null && _a$createdAt2 !== void 0 ? _a$createdAt2 : a.created_at) !== null && _ref0 !== void 0 ? _ref0 : 0);
        var dateB = new Date((_ref1 = (_b$createdAt2 = b.createdAt) !== null && _b$createdAt2 !== void 0 ? _b$createdAt2 : b.created_at) !== null && _ref1 !== void 0 ? _ref1 : 0);
        return dateA - dateB;
      });
      break;
    case 'COLLECTION_DEFAULT':
    case 'BEST_SELLING':
    default:
      break;
  }
  return sorted;
}
function CollectionProductGrid(props) {
  var _sortOptions$0$value, _sortOptions$, _cardSettings$pcard_l, _cardSettings$pcard_s, _settings$overlay_col;
  var {
    collectionHandle,
    settings,
    cardSettings,
    indexed,
    filters,
    products: initialProducts,
    productsCount: collectionProductsCount,
    allProductsCount,
    sortOptions,
    defaultSortBy
  } = getProps(props);
  var [activeFilters, setActiveFilters] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
  var [products, setProducts] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialProducts);
  var [allProducts, setAllProducts] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]); // All products for non-indexed filtering

  var allProductsDiscountMap = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (allProducts.length === 0) return null;
    return new Map(allProducts.map(p => [p.handle, p]));
  }, [allProducts]);
  var productsWithDiscount = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (!allProductsDiscountMap) return products;
    return products.map(p => {
      var _p$metafields, _source$metafields;
      var source = allProductsDiscountMap.get(p.handle);
      if (!source) return p;
      return _objectSpread(_objectSpread({}, p), {}, {
        hasApplicablePrice: source.hasApplicablePrice,
        variants: source.variants,
        metafields: _objectSpread(_objectSpread({}, p.metafields), {}, {
          custom: _objectSpread(_objectSpread({}, (_p$metafields = p.metafields) === null || _p$metafields === void 0 ? void 0 : _p$metafields.custom), {}, {
            discount: (_source$metafields = source.metafields) === null || _source$metafields === void 0 || (_source$metafields = _source$metafields.custom) === null || _source$metafields === void 0 ? void 0 : _source$metafields.discount
          })
        })
      });
    });
  }, [products, allProductsDiscountMap]);
  var [loadingAllProducts, setLoadingAllProducts] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [isGridLoading, setIsGridLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false); // true until first/sort/filter API response
  var [filterDrawerOpen, setFilterDrawerOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [facetDialogOpen, setFacetDialogOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [facetDrawerAnimating, setFacetDrawerAnimating] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var FACET_DRAWER_TRANSITION_MS = 600;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (filterDrawerOpen) {
      setFacetDialogOpen(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setFacetDrawerAnimating(true);
        });
      });
    } else {
      setFacetDrawerAnimating(false);
      var timer = setTimeout(() => {
        setFacetDialogOpen(false);
      }, FACET_DRAWER_TRANSITION_MS);
      return () => clearTimeout(timer);
    }
  }, [filterDrawerOpen]);
  var [sortBy, setSortBy] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultSortBy || ((_sortOptions$0$value = (_sortOptions$ = sortOptions[0]) === null || _sortOptions$ === void 0 ? void 0 : _sortOptions$.value) !== null && _sortOptions$0$value !== void 0 ? _sortOptions$0$value : 'COLLECTION_DEFAULT'));
  var [clientSidePage, setClientSidePage] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1); // Current page for client-side pagination
  var [apiFilters, setApiFilters] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]); // Filters from Storefront API (already filtered based on active filters)

  var {
    container = 'fixed',
    color_scheme = 'scheme-1',
    products_per_page = 20,
    columns_desktop = 4,
    columns_mobile = 2,
    columns_tablet = 3,
    columns_laptop = 4,
    column_gap = 'medium',
    row_gap = 'large',
    enable_filtering = true,
    enable_sorting = true,
    filter_type = 'vertical',
    // 'vertical' | 'drawer'
    expand_filter_groups = '',
    pagination: paginationType = 'load_more'
  } = settings;

  // Check if any active filter is non-indexed
  var hasActiveNonIndexedFilters = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (!Array.isArray(activeFilters) || activeFilters.length === 0) return false;
    return activeFilters.some(activeFilter => activeFilter.isNonIndexed);
  }, [activeFilters]);
  var {
    paginationMode,
    endCursor,
    hasNextPage,
    loading: loadMoreLoading,
    setPageInfo,
    loadMore,
    reset: resetPagination
  } = (0,_paginate__WEBPACK_IMPORTED_MODULE_11__.useLoadMoreState)({
    hasNonIndexedFilters: hasActiveNonIndexedFilters
  });

  // Loading for client-side filtering is now handled in the main useEffect with 500ms delay

  var nonIndexedFilterNameSpace = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => filters.filter(filter => filter.isNonIndexed).map(item => {
    return {
      namespace: item.namespace,
      key: item.key
    };
  }), [filters]);
  var hasFetchedAllProducts = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
  // Fetch all products from template on component mount
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    // Only fetch if we have a product count and haven't fetched yet
    if (!hasFetchedAllProducts.current && allProductsCount && allProductsCount > 0) {
      hasFetchedAllProducts.current = true;
      setLoadingAllProducts(true);
      (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
        try {
          var fetchedProducts = yield (0,JsComponents_api__WEBPACK_IMPORTED_MODULE_10__.fetchAllCollectionProductsFromTemplate)({
            collectionHandle,
            productsCount: allProductsCount
          });
          setAllProducts(fetchedProducts);
        } catch (error) {
          console.error('Error fetching all products from template:', error);
          setAllProducts([]);
        } finally {
          setLoadingAllProducts(false);
        }
      })();
    }
  }, [allProductsCount, collectionHandle]);

  // Track last API call to prevent duplicates (null = initial mount, not handled yet)
  var lastApiCallRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var initialPageInfoFetchedRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);

  // Fetch initial pageInfo in a callback after mount (React/DOM ready). Keeps Load More button visible
  // instead of running inside the main effect which can re-run and reset state.
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (initialProducts.length === 0 || initialPageInfoFetchedRef.current) return;
    initialPageInfoFetchedRef.current = true;
    (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var {
          sortKey,
          reverse
        } = getSortParams(sortBy);
        var response = yield (0,JsComponents_api__WEBPACK_IMPORTED_MODULE_10__.fetchCollectionProducts)({
          collectionHandle,
          filters: [],
          metafieldIdentifiers: nonIndexedFilterNameSpace,
          sortKey,
          reverse,
          first: products_per_page,
          after: null
        });
        if (response !== null && response !== void 0 && response.pageInfo) setPageInfo(response.pageInfo);
      } catch (e) {
        console.error('Error fetching collection pageInfo:', e);
      }
    })();
  }, [collectionHandle, sortBy, products_per_page, nonIndexedFilterNameSpace, setPageInfo, initialProducts.length]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var _sortOptions$0$value2, _sortOptions$2;
    // Skip on initial mount - use initialProducts that were passed in
    if (lastApiCallRef.current === null) {
      // Use initialProducts on mount when we have them
      if (initialProducts.length > 0) {
        setProducts(initialProducts);
      }
      // Mark as handled (use empty string to distinguish from null)
      lastApiCallRef.current = '';
      if (initialProducts.length > 0) return;
      // No initial products: fall through to run first API fetch (isGridLoading set below)
    }

    // Show loader for any filter/sort change after initial mount
    setIsGridLoading(true);

    // If any non-indexed filter is active, use all products from template and filter client-side
    // Don't make API calls - filtering and pagination happens client-side
    if (hasActiveNonIndexedFilters) {
      resetPagination();
      setClientSidePage(1); // Reset to first page when filters change

      setTimeout(() => {
        setIsGridLoading(false);
      }, 500);
      return;
    }

    // When no filters are active and sort matches initial, use initialProducts (no refetch).
    // If user changed sort, we must fall through and refetch with the new sortKey/reverse.
    var effectiveDefaultSort = defaultSortBy || ((_sortOptions$0$value2 = (_sortOptions$2 = sortOptions[0]) === null || _sortOptions$2 === void 0 ? void 0 : _sortOptions$2.value) !== null && _sortOptions$0$value2 !== void 0 ? _sortOptions$0$value2 : 'COLLECTION_DEFAULT');
    if (activeFilters.length === 0 && initialProducts.length > 0 && sortBy === effectiveDefaultSort) {
      setProducts(initialProducts);
      setApiFilters([]);
      if (lastApiCallRef.current !== '') {
        resetPagination();
      }
      lastApiCallRef.current = '';
      setIsGridLoading(false);
      return;
    }

    // No non-indexed filters active: use Storefront API with pagination
    // Create a key for this API call to prevent duplicates
    var apiCallKey = JSON.stringify({
      activeFilters: activeFilters.map(f => ({
        namespace: f.namespace,
        key: f.key,
        value: f.value
      })),
      sortBy,
      collectionHandle,
      products_per_page
    });

    // Skip if this is the same call as the last one
    if (lastApiCallRef.current === apiCallKey) {
      return;
    }
    lastApiCallRef.current = apiCallKey;
    resetPagination();
    (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var {
          sortKey,
          reverse
        } = getSortParams(sortBy);
        var response = yield (0,JsComponents_api__WEBPACK_IMPORTED_MODULE_10__.fetchCollectionProducts)({
          collectionHandle,
          filters: activeFilters && activeFilters.length > 0 ? activeFilters : [],
          metafieldIdentifiers: nonIndexedFilterNameSpace,
          sortKey,
          reverse,
          first: products_per_page,
          after: null
        });
        var {
          products: nextProducts,
          pageInfo,
          filters: nextFilters
        } = response;
        setProducts(Array.isArray(nextProducts) ? [...nextProducts] : []);
        if (pageInfo) setPageInfo(pageInfo);
        // Update filters from API (these are already filtered based on active filters)
        if (Array.isArray(nextFilters)) {
          setApiFilters(nextFilters);
        }
        // Note: filteredProductsCount is calculated in useMemo based on displayed products and pagination
      } catch (error) {
        console.error('Error fetching collection products:', error);
        setProducts([]);
      } finally {
        setIsGridLoading(false);
      }
    })();
  }, [activeFilters, sortBy, collectionHandle, products_per_page, nonIndexedFilterNameSpace, resetPagination, setPageInfo, hasActiveNonIndexedFilters, allProducts, loadingAllProducts, allProductsCount, defaultSortBy, initialProducts.length]);
  var handleLoadMore = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/(0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
    var _result$products;
    // For non-indexed filters, load more is handled client-side via pagination
    if (hasActiveNonIndexedFilters) {
      setClientSidePage(prev => prev + 1);
      return;
    }
    var {
      sortKey,
      reverse
    } = getSortParams(sortBy);
    var result = yield loadMore(/*#__PURE__*/(0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      var response = yield (0,JsComponents_api__WEBPACK_IMPORTED_MODULE_10__.fetchCollectionProducts)({
        collectionHandle,
        filters: activeFilters && activeFilters.length > 0 ? activeFilters : [],
        metafieldIdentifiers: nonIndexedFilterNameSpace,
        sortKey,
        reverse,
        first: products_per_page,
        after: endCursor
      });
      return response;
    }));
    if (result !== null && result !== void 0 && (_result$products = result.products) !== null && _result$products !== void 0 && _result$products.length) {
      setProducts(prev => [...prev, ...result.products]);
    }
    // Update filters from API response (for pagination, filters should be the same)
    if (result !== null && result !== void 0 && result.filters) {
      setApiFilters(result.filters);
    }
  }), [activeFilters, sortBy, collectionHandle, products_per_page, nonIndexedFilterNameSpace, endCursor, loadMore, hasActiveNonIndexedFilters]);
  var pcardListStyle = (_cardSettings$pcard_l = cardSettings.pcard_list_style) !== null && _cardSettings$pcard_l !== void 0 ? _cardSettings$pcard_l : 'card';
  var pcardStyle = (_cardSettings$pcard_s = cardSettings.pcard_style) !== null && _cardSettings$pcard_s !== void 0 ? _cardSettings$pcard_s : 'card';
  var cardColorClass = pcardStyle === 'card' ? "color-".concat(colorSchemeClass(cardSettings.pcard_color_scheme)) : undefined;

  // Apply all filters client-side when filters are active (for both API and client-side filtering)
  // This gives us the total filtered count for display
  var filteredProducts = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    // When filters are active, always filter allProducts to get total count
    // This works for both API and client-side filtering
    if (activeFilters.length > 0 && allProducts.length > 0) {
      return (0,_filterUtils__WEBPACK_IMPORTED_MODULE_4__.filterProducts)(allProducts, activeFilters);
    }
    // No filters active: return products as-is (from API or initialProducts)
    return productsWithDiscount;
  }, [productsWithDiscount, activeFilters, allProducts]);

  // Apply sorting: client-side when non-indexed filters are active, server-side otherwise
  // For display: use filteredProducts when non-indexed filters active, products from API when indexed filters active
  var sortedProducts = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (hasActiveNonIndexedFilters) {
      // Client-side sorting when any non-indexed filter is active
      return sortProducts(filteredProducts, sortBy);
    }
    // Server-side sorting (products already sorted by API)
    // Use products from API for display, not filteredProducts (which is used only for count)
    return productsWithDiscount;
  }, [filteredProducts, productsWithDiscount, sortBy, hasActiveNonIndexedFilters]);

  // Reset client-side page when sortBy changes and non-indexed filters are active
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (hasActiveNonIndexedFilters) {
      setClientSidePage(1);
    }
  }, [sortBy, hasActiveNonIndexedFilters]);

  // Client-side pagination: slice filtered products based on current page
  var paginatedProducts = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (hasActiveNonIndexedFilters) {
      var startIndex = (clientSidePage - 1) * products_per_page;
      var endIndex = startIndex + products_per_page;
      return sortedProducts.slice(0, endIndex);
    }
    return sortedProducts;
  }, [sortedProducts, hasActiveNonIndexedFilters, clientSidePage, products_per_page]);

  // Calculate if there are more products to load (client-side)
  var hasMoreClientSideProducts = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (hasActiveNonIndexedFilters) {
      // Check if there are more products beyond what's currently displayed
      var totalFiltered = sortedProducts.length;
      var currentlyDisplayed = paginatedProducts.length;
      return currentlyDisplayed < totalFiltered && totalFiltered > 0;
    }
    return false;
  }, [hasActiveNonIndexedFilters, paginatedProducts.length, sortedProducts.length]);
  var handleFilterChange = singleFilter => {
    var next = (0,_filterUtils__WEBPACK_IMPORTED_MODULE_4__.toggleFilterValue)({
      activeFilters,
      singleFilter
    });
    setActiveFilters(next);
  };
  var handlePriceRangeChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((minCents, maxCents) => {
    setActiveFilters(prev => {
      var rest = prev.filter(f => !(f.filterType === 'price' && (f.key === 'gte' || f.key === 'lte')));
      var next = [...rest];
      if (minCents != null && minCents !== '') {
        next.push({
          filterType: 'price',
          namespace: 'price',
          key: 'gte',
          value: minCents
        });
      }
      if (maxCents != null && maxCents !== '') {
        next.push({
          filterType: 'price',
          namespace: 'price',
          key: 'lte',
          value: maxCents
        });
      }
      return next;
    });
  }, []);
  var displayChips = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => (0,_filterUtils__WEBPACK_IMPORTED_MODULE_4__.getDisplayChips)(activeFilters), [activeFilters]);

  // Create a map of disabled filter options from API filters (count === 0)
  // Key format: `${namespace}.${key}.${value}` for matching
  var disabledFilterOptions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    var disabledSet = new Set();
    apiFilters.forEach(apiFilter => {
      if (!apiFilter.values || apiFilter.values.length === 0) return;

      // Parse the first value's input to get namespace and key
      var namespace = null;
      var key = null;
      if (apiFilter.values[0].input) {
        try {
          var input = typeof apiFilter.values[0].input === 'string' ? JSON.parse(apiFilter.values[0].input) : apiFilter.values[0].input;
          if (input.productMetafield) {
            namespace = input.productMetafield.namespace;
            key = input.productMetafield.key;
          } else if (input.variantMetafield) {
            namespace = input.variantMetafield.namespace;
            key = input.variantMetafield.key;
          }
        } catch (e) {
          console.warn('Failed to parse filter input:', e);
          return;
        }
      }
      if (!namespace || !key) return;

      // Check each value - if count is 0, add to disabled set
      apiFilter.values.forEach(value => {
        if (value.count === 0) {
          // Parse the value from input to get the actual filter value
          try {
            var _input = typeof value.input === 'string' ? JSON.parse(value.input) : value.input;
            var filterValue = null;
            if (_input.productMetafield) {
              filterValue = _input.productMetafield.value;
            } else if (_input.variantMetafield) {
              filterValue = _input.variantMetafield.value;
            }
            if (filterValue != null) {
              // Create key for matching: namespace.key.value
              var disabledKey = "".concat(namespace, ".").concat(key, ".").concat(filterValue);
              disabledSet.add(disabledKey);
            }
          } catch (e) {
            console.warn('Failed to parse value input:', e);
          }
        }
      });
    });
    return disabledSet;
  }, [apiFilters]);
  var filterUIProps = {
    filters,
    activeFilters,
    handleFilterChange,
    onPriceRangeChange: handlePriceRangeChange,
    expandFilterGroups: expand_filter_groups,
    disabledFilterOptions
  };
  var overlayColorScheme = (_settings$overlay_col = settings.overlay_color_scheme) !== null && _settings$overlay_col !== void 0 ? _settings$overlay_col : 'scheme-1';

  // Calculate product count text
  // Format: showing {paginatedCount} of {filteredCount}
  // - paginatedCount: currently displayed products
  // - filteredCount: total filtered count (filteredProducts.length when filters active, Liquid count when no filters)
  var productCount = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (indexed || hasActiveNonIndexedFilters && allProducts.length > 0) {
      var paginatedCount = hasActiveNonIndexedFilters ? paginatedProducts.length : sortedProducts.length;

      // Determine filteredCount: use filteredProducts.length when filters are active, otherwise Liquid count
      var hasActiveFilters = activeFilters.length > 0;
      var filteredCount;
      if (hasActiveFilters && filteredProducts.length > 0) {
        // When filters are active, use the total filtered count from client-side filtering
        filteredCount = filteredProducts.length;
      } else {
        // No filters active: use Liquid count
        filteredCount = collectionProductsCount !== null && collectionProductsCount !== void 0 ? collectionProductsCount : allProductsCount;
      }
      if (filteredCount != null && filteredCount > 0) {
        return "Showing ".concat(paginatedCount, " of ").concat(filteredCount, " ").concat(filteredCount === 1 ? 'product' : 'products');
      }
      return "".concat(paginatedCount, " ").concat(paginatedCount === 1 ? 'product' : 'products');
    }
    return 'Loading…';
  }, [indexed, hasActiveNonIndexedFilters, allProducts.length, sortedProducts.length, paginatedProducts.length, collectionProductsCount, allProductsCount, activeFilters.length, filteredProducts.length]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "collection collection__inner",
    "data-collection-handle": collectionHandle
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_CollectionToolbar__WEBPACK_IMPORTED_MODULE_7__["default"], {
    enable_filtering: enable_filtering,
    enable_sorting: enable_sorting,
    enable_compare: settings.enable_compare !== false,
    filter_type: filter_type,
    filterDrawerOpen: filterDrawerOpen,
    onFilterDrawerOpen: () => setFilterDrawerOpen(prev => !prev),
    productCount: productCount,
    sortBy: sortBy,
    sortOptions: sortOptions,
    onSortChange: value => setSortBy(value)
  }), enable_filtering && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_FilterUI__WEBPACK_IMPORTED_MODULE_5__.ActiveFilterChips, {
    chips: displayChips,
    onRemoveChip: chip => chip.getNextFilters && setActiveFilters(chip.getNextFilters(activeFilters)),
    onClearAll: setActiveFilters
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "collection__content flex"
  }, enable_filtering && filter_type === 'vertical' && filters.length > 0 && !((indexed || hasActiveNonIndexedFilters) && products.length === 0 && !loadingAllProducts && allProducts.length === 0) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "no-js-hidden hidden xl:block",
    id: "FacetFiltersContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "sticky-element z-8",
    style: {
      '--sticky-offset': '7.2rem'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_FilterUI__WEBPACK_IMPORTED_MODULE_5__["default"], filterUIProps))), enable_filtering && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "facet-drawer-wrapper no-js-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__.Dialog, {
    open: facetDialogOpen,
    onClose: () => setFilterDrawerOpen(false),
    id: "FacetDrawer",
    className: "drawer drawer--left facet-drawer",
    "aria-label": "Filters"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__.DialogBackdrop, {
    className: "fixed-overlay",
    "aria-controls": "FacetDrawer",
    style: {
      zIndex: 0,
      transition: "opacity ".concat(FACET_DRAWER_TRANSITION_MS, "ms cubic-bezier(0.7, 0, 0.2, 1)"),
      opacity: facetDrawerAnimating ? 1 : 0
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "fixed inset-0 overflow-hidden",
    style: {
      zIndex: 1
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "absolute inset-0 overflow-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pointer-events-none fixed inset-y-0 left-0 flex max-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__.DialogPanel, {
    className: "drawer__inner color-".concat(overlayColorScheme, " pointer-events-auto flex flex-col w-full max-w-[50rem]"),
    style: {
      zIndex: 10,
      transition: "transform ".concat(FACET_DRAWER_TRANSITION_MS, "ms cubic-bezier(0.7, 0, 0.2, 1)"),
      transform: facetDrawerAnimating ? 'translate3d(0, 0, 0)' : 'translate3d(-100%, 0, 0)'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "drawer__content flex flex-col h-full w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "drawer__header facet-drawer__header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "drawer__header-inner flex items-center justify-between gap-3"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h2", {
    className: "drawer__heading h4"
  }, "Filters"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    type: "button",
    className: "drawer__close-btn z-1",
    "aria-controls": "FacetDrawer",
    "aria-label": "Close",
    onClick: () => setFilterDrawerOpen(false)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(IconClose, {
    size: "large"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "drawer__body flex-grow v-scrollable",
    id: "DrawerFacetFiltersContainer"
  }, enable_sorting && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "flex items-center gap-3 lg:hidden facet-short-drawer",
    id: "SortByContainerMobile"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_SortBy__WEBPACK_IMPORTED_MODULE_8__["default"], {
    sortBy: sortBy,
    sortOptions: sortOptions,
    onChange: value => setSortBy(value),
    enable_sorting: enable_sorting,
    wrapperClassName: "no-js-hidden flex items-center gap-2 w-full"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_FilterUI__WEBPACK_IMPORTED_MODULE_5__["default"], filterUIProps))))))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "flex flex-col flex-grow",
    id: "ProductGridWrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    id: "ProductGridContainer"
  }, isGridLoading || loadingAllProducts && paginatedProducts.length === 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    id: "ProductsList",
    "data-layout": "grid",
    "aria-busy": "true",
    "aria-label": "Loading products",
    className: "grid-list products-list products-list--list-".concat(pcardListStyle, " f-grid f-grid--gap-").concat(column_gap, " f-grid--row-gap-").concat(row_gap),
    style: {
      '--f-columns-mobile': columns_mobile,
      '--f-columns-md': columns_tablet,
      '--f-columns-lg': columns_laptop,
      '--f-columns-xl': columns_desktop
    },
    "data-grid-class": cardColorClass,
    "data-list-class": cardColorClass
  }, Array.from({
    length: products_per_page
  }, (_, i) => {
    var _cardSettings$pcard_s2, _cardSettings$pcard_c;
    var skStyle = (_cardSettings$pcard_s2 = cardSettings.pcard_style) !== null && _cardSettings$pcard_s2 !== void 0 ? _cardSettings$pcard_s2 : 'card';
    var skColor = colorSchemeClass(cardSettings.pcard_color_scheme);
    var skAlign = (_cardSettings$pcard_c = cardSettings.pcard_content_alignment) !== null && _cardSettings$pcard_c !== void 0 ? _cardSettings$pcard_c : 'left';
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      key: "skeleton-".concat(i),
      className: "f-column product-column"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-card product-card--skeleton product-card-style-".concat(skStyle).concat(skStyle === 'card' ? " color-".concat(skColor) : ''),
      "aria-hidden": "true"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-card__wrapper h-full tw-flex tw-flex-col"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-card__image-wrapper product-card__image-wrapper--main-only color-".concat(skColor, " bg-none")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "block"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "media-wrapper product-card__image product-card__image--main tw-animate-pulse !tw-block",
      style: {
        '--aspect-ratio': 1,
        backgroundColor: 'var(--color-foreground-muted, #e5e5e5)',
        borderRadius: 'var(--card-corner-radius, 0)'
      }
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-card__info tw-flex tw-flex-col tw-flex-1 text-".concat(skAlign)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-animate-pulse !tw-block",
      style: {
        height: '0.875em',
        backgroundColor: 'var(--color-foreground-muted, #e5e5e5)',
        borderRadius: 4,
        marginBottom: '0.25rem',
        maxWidth: '40%'
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-animate-pulse !tw-block",
      style: {
        height: '1em',
        backgroundColor: 'var(--color-foreground-muted, #e5e5e5)',
        borderRadius: 4,
        marginBottom: '0.5rem',
        maxWidth: '85%'
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-animate-pulse !tw-block",
      style: {
        height: '1em',
        backgroundColor: 'var(--color-foreground-muted, #e5e5e5)',
        borderRadius: 4,
        marginBottom: '0.5rem',
        maxWidth: '60%'
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "product-card__bottom tw-flex tw-flex-col tw-flex-1 tw-gap-2"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-animate-pulse !tw-block",
      style: {
        height: '0.875em',
        backgroundColor: 'var(--color-foreground-muted, #e5e5e5)',
        borderRadius: 4,
        maxWidth: '35%'
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-animate-pulse !tw-block tw-mt-auto",
      style: {
        height: '2.75rem',
        backgroundColor: 'var(--color-foreground-muted, #e5e5e5)',
        borderRadius: 'var(--button-corner-radius, 0)'
      },
      "aria-hidden": "true"
    }))))));
  })) : (indexed || hasActiveNonIndexedFilters && allProducts.length > 0) && paginatedProducts.length > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    id: "ProductsList",
    "data-layout": "grid",
    className: "grid-list products-list products-list--list-".concat(pcardListStyle, " f-grid f-grid--gap-").concat(column_gap, " f-grid--row-gap-").concat(row_gap),
    style: {
      '--f-columns-mobile': columns_mobile,
      '--f-columns-md': columns_tablet,
      '--f-columns-lg': columns_laptop,
      '--f-columns-xl': columns_desktop
    },
    "data-grid-class": cardColorClass,
    "data-list-class": cardColorClass
  }, paginatedProducts.map(product => {
    var _product$id;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      key: (_product$id = product.id) !== null && _product$id !== void 0 ? _product$id : product.handle,
      className: "f-column product-column"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_ProductCard__WEBPACK_IMPORTED_MODULE_6__["default"], {
      product: product,
      cardSettings: _objectSpread(_objectSpread({}, cardSettings), {}, {
        enable_compare: settings.enable_compare !== false
      })
    }));
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_Empty__WEBPACK_IMPORTED_MODULE_9__["default"], {
    isLoading: loadingAllProducts || !indexed && !hasActiveNonIndexedFilters || hasActiveNonIndexedFilters && allProducts.length === 0 && allProductsCount > 0,
    isEmpty: (indexed || hasActiveNonIndexedFilters) && products.length === 0 && !loadingAllProducts && allProducts.length === 0,
    hasFilters: sortedProducts.length === 0 && activeFilters.length > 0 && !loadingAllProducts,
    onClearFilters: () => setActiveFilters([])
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_paginate__WEBPACK_IMPORTED_MODULE_11__.LoadMoreButton, {
    onClick: handleLoadMore,
    loading: loadMoreLoading,
    hasNextPage: hasActiveNonIndexedFilters ? hasMoreClientSideProducts : hasNextPage && sortedProducts.length > 0,
    paginationMode: paginationMode,
    paginationType: paginationType
  }))));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/CollectionToolbar.js"
/*!**************************************************************************!*\
  !*** ./js/components/react/collection-product-grid/CollectionToolbar.js ***!
  \**************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CollectionToolbar)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _SortBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./SortBy */ "./js/components/react/collection-product-grid/SortBy.js");


function IconFunnel() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    className: "icon icon--large",
    "aria-hidden": true,
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M2.66244 4.79531C2.58111 4.70581 2.5275 4.59464 2.5081 4.47527C2.48869 4.35591 2.50434 4.23348 2.55313 4.12283C2.60192 4.01218 2.68177 3.91806 2.78299 3.85188C2.88421 3.7857 3.00245 3.75031 3.12338 3.75H16.8734C16.9944 3.75001 17.1129 3.78518 17.2144 3.85124C17.3158 3.9173 17.3959 4.0114 17.4449 4.12212C17.4939 4.23283 17.5096 4.35538 17.4903 4.47489C17.4709 4.5944 17.4173 4.70571 17.3359 4.79531L11.8734 10.625V15.207C11.8734 15.31 11.8481 15.4113 11.7996 15.5021C11.7511 15.5928 11.6809 15.6702 11.5953 15.7273L9.09525 17.3937C9.00122 17.4565 8.89192 17.4926 8.77901 17.4981C8.6661 17.5036 8.55381 17.4784 8.45408 17.4252C8.35435 17.372 8.27092 17.2927 8.21269 17.1958C8.15445 17.0989 8.12359 16.988 8.12338 16.875V10.625L2.66244 4.79531Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function CollectionToolbar(_ref) {
  var {
    enable_filtering = true,
    enable_sorting = true,
    enable_compare = false,
    filter_type = 'vertical',
    filterDrawerOpen = false,
    onFilterDrawerOpen,
    productCount,
    sortBy,
    sortOptions = [],
    onSortChange
  } = _ref;
  if (!enable_filtering && !enable_sorting && !enable_compare) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "sticky-element grid gap-5 z-9",
    style: {
      '--sticky-offset': '0px'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "collection__toolbar flex flex-wrap items-end md:items-center justify-between gap-x-2 "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "collection__toolbar-left flex md:items-center flex-col md:flex-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    "data-facet-loading": true,
    className: "md:order-last"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    id: "ProductCount",
    className: "m-0 text-subtext",
    role: "status",
    "aria-live": "polite"
  }, productCount || 'Loading…')), enable_filtering && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "facet-drawer-wrapper no-js-hidden ".concat(filter_type === 'vertical' ? 'flex xl:hidden' : 'flex')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    className: "btn btn--secondary gap-2 facet-drawer-button",
    "aria-controls": "FacetDrawer",
    "aria-expanded": filterDrawerOpen,
    onClick: onFilterDrawerOpen
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "btn__text flex gap-1 items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(IconFunnel, null), "Filters")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "collection__toolbar-right flex items-end md:items-center flex-col md:flex-row"
  }, enable_compare && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("compare-switch", {
    className: "flex items-center no-js-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    type: "checkbox",
    id: "ProductCompareSwitch",
    className: "switch"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
    htmlFor: "ProductCompareSwitch",
    className: "flex items-center gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "text-nowrap font-body-bolder"
  }, "Compare:"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "switch-slider"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_SortBy__WEBPACK_IMPORTED_MODULE_1__["default"], {
    sortBy: sortBy,
    sortOptions: sortOptions,
    onChange: onSortChange,
    enable_sorting: enable_sorting
  }))));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/Empty.js"
/*!**************************************************************!*\
  !*** ./js/components/react/collection-product-grid/Empty.js ***!
  \**************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Empty)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function Empty(_ref) {
  var {
    isLoading = false,
    isEmpty = false,
    hasFilters = false,
    onClearFilters
  } = _ref;
  if (isLoading) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "empty-state flex flex-col items-center justify-center gap-6 text-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "m-0 text-subtext"
    }, "Loading\u2026"));
  }
  if (isEmpty) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "empty-state flex flex-col items-center justify-center gap-6 text-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "gap-3 flex flex-col items-center justify-center text-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "empty-state__icon",
      "aria-hidden": true
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "h4 m-0"
    }, "This collection is empty")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      href: "/",
      className: "btn btn--primary"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "btn__text"
    }, "Continue shopping")));
  }
  if (hasFilters) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "empty-state flex flex-col items-center justify-center gap-6 text-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "gap-3 flex flex-col items-center justify-center text-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "empty-state__icon",
      "aria-hidden": true
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "h4 m-0"
    }, "No products match your filters"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "m-0 text-subtext"
    }, "Try removing some filters")), onClearFilters && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
      type: "button",
      className: "btn btn--primary",
      onClick: onClearFilters
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "btn__text"
    }, "Clear all")));
  }
  return null;
}

/***/ },

/***/ "./js/components/react/collection-product-grid/FilterOptionValue.js"
/*!**************************************************************************!*\
  !*** ./js/components/react/collection-product-grid/FilterOptionValue.js ***!
  \**************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ FilterOptionValue)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FilterOptionValue(_ref) {
  var {
    option,
    handleFilterChange,
    id: inputId,
    metaFieldData,
    checked,
    disabled = false
  } = _ref;
  var handleToggle = checked => {
    if (disabled) return; // Don't allow toggling disabled options
    // const next = toggleFilterValue(activeFilters, value, checked);
    handleFilterChange(_objectSpread(_objectSpread(_objectSpread({}, option), metaFieldData), {}, {
      checked
    }));
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("li", {
    key: "".concat(option.value),
    className: "flex items-center gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    type: "checkbox",
    name: option.value,
    value: option.value,
    className: "checkbox",
    id: inputId,
    checked: checked,
    disabled: disabled,
    onChange: e => handleToggle(e.target.checked)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("label", {
    htmlFor: inputId,
    className: "flex flex-grow justify-between items-center gap-1 text-subtext reversed-link ".concat(disabled ? 'opacity-60' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "reversed-link__text"
  }, option.label)));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/FilterUI.js"
/*!*****************************************************************!*\
  !*** ./js/components/react/collection-product-grid/FilterUI.js ***!
  \*****************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActiveFilterChips: () => (/* binding */ ActiveFilterChips),
/* harmony export */   "default": () => (/* binding */ FilterUI)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _filterUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./filterUtils */ "./js/components/react/collection-product-grid/filterUtils.js");
/* harmony import */ var _FilterOptionValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./FilterOptionValue */ "./js/components/react/collection-product-grid/FilterOptionValue.js");
/* harmony import */ var _PriceRangeFilter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PriceRangeFilter */ "./js/components/react/collection-product-grid/PriceRangeFilter.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





/** Plus/minus toggle icon to match theme icon-plus-toggle */
function IconPlusToggle(_ref) {
  var {
    open,
    size = 'small'
  } = _ref;
  var sizeClass = size === 'small' ? 'icon--small' : 'icon--medium';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-plus-toggle ".concat(sizeClass),
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    className: "horizontal",
    d: "M3.125 10H16.875",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    className: "vertical",
    d: "M10 3.125V16.875",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: open ? {
      opacity: 0
    } : undefined
  }));
}

/**
 * FilterUI — vertical list of filter groups.
 * Matches original facets.liquid: accordion-details facet-accordion-details, accordion-details__summary, accordion-details__content, grid gap-3 list.
 */
function FilterUI(_ref2) {
  var {
    filters = [],
    activeFilters = [],
    handleFilterChange,
    onPriceRangeChange,
    expandFilterGroups = '',
    disabledFilterOptions = new Set()
  } = _ref2;
  var [openGroups, setOpenGroups] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
  var expandList = (expandFilterGroups || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  var normalized = filters.map((f, i) => (0,_filterUtils__WEBPACK_IMPORTED_MODULE_2__.normalizeFilter)(f, i)).filter(Boolean);
  var toggleGroup = id => {
    setOpenGroups(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [id]: !prev[id]
    }));
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "FilterUI lg:tw-max-h-[80vh] tw-overflow-y-auto"
  }, normalized.map(filter => {
    var isOpen = openGroups[filter.id] !== false && (expandList.includes(filter.label.toLowerCase()) || openGroups[filter.id] === true);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("details", {
      key: filter.id,
      className: "accordion-details facet-accordion-details",
      "data-index": filter.id,
      open: isOpen
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("summary", {
      className: "accordion-details__summary flex items-center justify-between",
      onClick: e => {
        e.preventDefault();
        toggleGroup(filter.id);
      },
      role: "button",
      "aria-expanded": isOpen
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "h6"
    }, filter.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(IconPlusToggle, {
      open: isOpen,
      size: "small"
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "accordion-details__content parent-display flex flex-col gap-3".concat(filter.filterType === 'price' ? ' accordion-details__content--price' : '')
    }, filter.filterType === 'price' ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_PriceRangeFilter__WEBPACK_IMPORTED_MODULE_4__["default"], {
      minPrice: filter.minPrice,
      maxPrice: filter.maxPrice,
      rangeMax: filter.rangeMax,
      priceRange: (() => {
        var fromActive = (0,_filterUtils__WEBPACK_IMPORTED_MODULE_2__.getPriceRangeFromActiveFilters)(activeFilters);
        if (!fromActive) return undefined;
        return {
          min: fromActive.min != null ? fromActive.min / 100 : null,
          max: fromActive.max != null ? fromActive.max / 100 : null
        };
      })(),
      onPriceRangeChange: typeof onPriceRangeChange === 'function' ? (minDollars, maxDollars) => {
        var minCents = minDollars != null ? Math.round(minDollars * 100) : null;
        var maxCents = maxDollars != null ? Math.round(maxDollars * 100) : null;
        onPriceRangeChange(minCents, maxCents);
      } : undefined
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("ul", {
      className: "grid gap-3"
    }, (filter.values || []).map((valuesOption, idx) => {
      var checked = activeFilters.some(f => f.value === valuesOption.value);
      // Check if this option should be disabled (only for indexed filters)
      var disabledKey = filter.namespace && filter.key && valuesOption.value ? "".concat(filter.namespace, ".").concat(filter.key, ".").concat(valuesOption.value) : null;
      var disabled = !filter.isNonIndexed && disabledKey && disabledFilterOptions.has(disabledKey);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_FilterOptionValue__WEBPACK_IMPORTED_MODULE_3__["default"], {
        key: "".concat(filter.id, "-").concat(idx),
        option: valuesOption,
        activeFilters: activeFilters,
        handleFilterChange: handleFilterChange,
        metaFieldData: {
          namespace: filter.namespace,
          key: filter.key,
          isNonIndexed: filter.isNonIndexed,
          filterType: filter.filterType
        },
        checked: checked,
        id: "".concat(filter.id, "-").concat(idx),
        disabled: disabled
      });
    }))));
  }));
}

/** Inline close icon to match theme icon-close */
function IconClose(_ref3) {
  var {
    size = 'extra-small',
    className = ''
  } = _ref3;
  var sizeClass = size === 'large' ? 'icon--large' : 'icon--extra-small';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false",
    className: "icon icon-close ".concat(sizeClass, " ").concat(className).trim(),
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M18.75 5.13496L5.25 18.8544",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M18.75 18.8544L5.25 5.13496",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

/**
 * Active filter chips — show selected filters and allow removing one or all.
 * Uses display chips so price range appears as one chip (e.g. "$969 - $10,434").
 * Matches original facets-active.liquid: facets-active, facet-remove btn btn--secondary, facet-clear-all btn--link.
 */
function ActiveFilterChips(_ref4) {
  var {
    chips,
    onRemoveChip,
    onClearAll
  } = _ref4;
  if (!Array.isArray(chips) || chips.length === 0) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "facets-active flex flex-wrap items-center gap-2",
    id: "FacetFiltersActive"
  }, chips.map(chip => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    key: chip.key,
    type: "button",
    className: "facet-remove btn btn--secondary flex relative",
    "aria-label": "Remove ".concat(chip.label),
    onClick: () => {
      if (typeof onRemoveChip === 'function' && chip.getNextFilters) {
        onRemoveChip(chip);
      }
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "btn__text flex items-center justify-between gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "facet-title text-wrap flex items-center gap-2"
  }, chip.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(IconClose, {
    size: "extra-small"
  })))), typeof onClearAll === 'function' && chips.length > 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    type: "button",
    className: "facet-clear-all btn--link",
    onClick: () => onClearAll([])
  }, "Clear all"));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/PriceRangeFilter.js"
/*!*************************************************************************!*\
  !*** ./js/components/react/collection-product-grid/PriceRangeFilter.js ***!
  \*************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PriceRangeFilter)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ProductCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ProductCard */ "./js/components/react/collection-product-grid/ProductCard.js");


var PRICE_RANGE_MIN = 0;
var PRICE_RANGE_MAX = 11000; // 0–11k only

/**
 * Price range filter UI .
 * Uses same price convention as finalPrice / finalCompareAtPrice (cents); display via formatPrice from ProductCard.
 * Range is fixed 0–11k (dollars).
 */
function PriceRangeFilter(_ref) {
  var _priceRange$min, _priceRange$max;
  var {
    priceRange,
    onPriceRangeChange,
    currencySymbol = '$'
  } = _ref;
  var rangeMin = (_priceRange$min = priceRange === null || priceRange === void 0 ? void 0 : priceRange.min) !== null && _priceRange$min !== void 0 ? _priceRange$min : null;
  var rangeMaxVal = (_priceRange$max = priceRange === null || priceRange === void 0 ? void 0 : priceRange.max) !== null && _priceRange$max !== void 0 ? _priceRange$max : null;
  var [minInput, setMinInput] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => rangeMin != null ? String(rangeMin) : '');
  var [maxInput, setMaxInput] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => rangeMaxVal != null ? String(rangeMaxVal) : '');
  var minBoundDollars = PRICE_RANGE_MIN;
  var maxBoundDollars = PRICE_RANGE_MAX;
  var stepValue = Math.max(0.01, (maxBoundDollars - minBoundDollars) / 100) || 1;
  var minNum = minInput === '' ? null : parseFloat(minInput);
  var maxNum = maxInput === '' ? null : parseFloat(maxInput);
  var lowerProgress = maxBoundDollars > 0 && minNum != null ? minNum / maxBoundDollars * 100 : 0;
  var higherProgress = maxBoundDollars > 0 && maxNum != null ? maxNum / maxBoundDollars * 100 : 100;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMinInput(rangeMin != null ? String(rangeMin) : '');
    setMaxInput(rangeMaxVal != null ? String(rangeMaxVal) : '');
  }, [rangeMin, rangeMaxVal]);
  var applyRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    var min = minInput === '' ? null : parseFloat(minInput);
    var max = maxInput === '' ? null : parseFloat(maxInput);
    if (min != null || max != null) {
      if (min === rangeMin && max === rangeMaxVal) return;
      onPriceRangeChange(min !== null && min !== void 0 ? min : null, max !== null && max !== void 0 ? max : null);
    }
  }, [minInput, maxInput, onPriceRangeChange, rangeMin, rangeMaxVal]);
  var handleMinBlur = () => applyRange();
  var handleMaxBlur = () => applyRange();
  var handleKeyDown = e => {
    if (e.key === 'Enter') applyRange();
  };
  var handleMinSliderChange = e => {
    var v = parseFloat(e.target.value);
    setMinInput(String(v));
  };
  var handleMaxSliderChange = e => {
    var v = parseFloat(e.target.value);
    setMaxInput(String(v));
  };
  var handleSliderPointerUp = () => {
    var min = minInput === '' ? null : parseFloat(minInput);
    var max = maxInput === '' ? null : parseFloat(maxInput);
    if (min != null || max != null) {
      if (min === rangeMin && max === rangeMaxVal) return;
      onPriceRangeChange(min !== null && min !== void 0 ? min : null, max !== null && max !== void 0 ? max : null);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "grid",
    style: {
      gap: '1.8rem'
    }
  }, maxBoundDollars > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "text-subtext"
  }, "The highest price is ", (0,_ProductCard__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(maxBoundDollars * 100)), maxBoundDollars > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "facet-range-wrapper relative",
    style: {
      '--range-min': "".concat(lowerProgress, "%"),
      '--range-max': "".concat(higherProgress, "%")
    },
    onPointerUp: handleSliderPointerUp,
    onPointerLeave: handleSliderPointerUp
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "facet-range facet-range__min w-full",
    type: "range",
    min: minBoundDollars,
    max: maxBoundDollars,
    step: stepValue,
    value: minNum !== null && minNum !== void 0 ? minNum : minBoundDollars,
    onChange: handleMinSliderChange,
    "aria-label": "Minimum price"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    className: "facet-range facet-range__max w-full absolute",
    type: "range",
    min: minBoundDollars,
    max: maxBoundDollars,
    step: stepValue,
    value: maxNum !== null && maxNum !== void 0 ? maxNum : maxBoundDollars,
    onChange: handleMaxSliderChange,
    "aria-label": "Maximum price",
    style: {
      insetBlockStart: 0,
      insetInlineStart: 0
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "facet-input-wrapper flex items-center gap-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex items-center flex-grow relative gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
    htmlFor: "FacetFormInputFromPrice-react",
    className: "visually-hidden"
  }, "From"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "facet-range__symbol"
  }, currencySymbol), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    id: "FacetFormInputFromPrice-react",
    className: "form-control facet-range__input",
    type: "number",
    inputMode: "numeric",
    autoComplete: "off",
    placeholder: "0",
    min: minBoundDollars,
    max: maxBoundDollars,
    step: stepValue,
    value: minInput,
    onChange: e => setMinInput(e.target.value),
    onBlur: handleMinBlur,
    onKeyDown: handleKeyDown,
    "aria-label": "Minimum price"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "flex items-center flex-grow relative gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
    htmlFor: "FacetFormInputToPrice-react",
    className: "visually-hidden"
  }, "To"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "facet-range__symbol"
  }, currencySymbol), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", {
    id: "FacetFormInputToPrice-react",
    className: "form-control facet-range__input",
    type: "number",
    inputMode: "numeric",
    autoComplete: "off",
    placeholder: String(Math.ceil(maxBoundDollars) || ''),
    min: minBoundDollars,
    max: maxBoundDollars,
    step: stepValue,
    value: maxInput,
    onChange: e => setMaxInput(e.target.value),
    onBlur: handleMaxBlur,
    onKeyDown: handleKeyDown,
    "aria-label": "Maximum price"
  }))));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/ProductCard.js"
/*!********************************************************************!*\
  !*** ./js/components/react/collection-product-grid/ProductCard.js ***!
  \********************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductCard),
/* harmony export */   formatPrice: () => (/* binding */ formatPrice)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _product_customise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../product-customise */ "./js/components/product-customise.js");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../api */ "./js/components/api.js");





/** Debounced Affirm refresh so many cards mounting don't each call refresh. */
var affirmRefreshTimer = null;
function scheduleAffirmRefresh() {
  if (affirmRefreshTimer) return;
  affirmRefreshTimer = window.setTimeout(() => {
    var _affirm$ui, _affirm$ui2;
    affirmRefreshTimer = null;
    var affirm = typeof window !== 'undefined' ? window.affirm : undefined;
    if (affirm !== null && affirm !== void 0 && (_affirm$ui = affirm.ui) !== null && _affirm$ui !== void 0 && _affirm$ui.refresh) {
      affirm.ui.refresh();
    } else if (affirm !== null && affirm !== void 0 && (_affirm$ui2 = affirm.ui) !== null && _affirm$ui2 !== void 0 && _affirm$ui2.ready) {
      affirm.ui.ready(() => {
        var _affirm$ui3;
        if ((_affirm$ui3 = affirm.ui) !== null && _affirm$ui3 !== void 0 && _affirm$ui3.refresh) affirm.ui.refresh();
      });
    }
  }, 80);
}

/** Format price in cents for display (same convention as finalPrice / finalCompareAtPrice). */
function formatPrice(price) {
  var priceInDollar = price / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    roundingMode: 'floor'
  }).format(priceInDollar);
}

/** Build Shopify collection filter URL from value (e.g. /collections/vendors?q=...). No need to pass URLs in JSON. */
function collectionFilterUrl(collectionPath, value) {
  if (!value) return '#';
  return "".concat(collectionPath, "?q=").concat(encodeURIComponent(String(value)));
}

/** Theme color_scheme can be a string (e.g. "scheme-1") or an object; class names need a string. */
function colorSchemeClass(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scheme-1';
  if (typeof value === 'string' && value) return value;
  if (value && typeof value === 'object' && typeof value.setting_identifier === 'string') return value.setting_identifier;
  return fallback;
}

/** Metafield list count: add_ons / mandatory_products are JSON arrays; surcharge_for_california_in_percentage is scalar. All use same "has value" check for View options. */
function metafieldListCount(val) {
  if (val == null || val === '') return 0;
  if (Array.isArray(val)) return val.length;
  if (typeof val === 'string') {
    try {
      var parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed.length : 0;
    } catch (_unused) {
      return 0;
    }
  }
  return 0;
}
function ProductCard(_ref) {
  var _product$url, _product$handle, _cardSettings$pcard_s, _cardSettings$pcard_c, _cardSettings$pcard_b, _ref2, _product$first_varian, _product$variants, _product$images, _product$images2, _product$priceRange, _priceRange$min, _priceRange$max, _product$model_number, _product$metafields, _v$available, _product$metafields2, _product$metafields3, _product$metafields4, _product$variants$len, _product$variants2, _ref3, _featuredImage$alt, _ref4, _secondImage$alt;
  var {
    product,
    cardSettings = {}
  } = _ref;
  var href = (_product$url = product.url) !== null && _product$url !== void 0 ? _product$url : "/products/".concat((_product$handle = product.handle) !== null && _product$handle !== void 0 ? _product$handle : '');
  var isAddOn = Array.isArray(product.tags) && product.tags.some(t => String(t).toLowerCase() === 'add-ons');
  var style = (_cardSettings$pcard_s = cardSettings.pcard_style) !== null && _cardSettings$pcard_s !== void 0 ? _cardSettings$pcard_s : 'card';
  var colorScheme = colorSchemeClass(cardSettings.pcard_color_scheme);
  var overlayScheme = colorSchemeClass(cardSettings.pcard_overlay_color_scheme, colorScheme);
  var showVendor = cardSettings.pcard_show_vendor !== false;
  var showType = cardSettings.pcard_show_type !== false;
  var showPrice = cardSettings.pcard_show_price !== false;
  var showSoldOutBadge = cardSettings.pcard_show_badge_soldout !== false;
  var showSaleBadge = cardSettings.pcard_show_sale_badge !== false;
  var contentAlign = (_cardSettings$pcard_c = cardSettings.pcard_content_alignment) !== null && _cardSettings$pcard_c !== void 0 ? _cardSettings$pcard_c : 'left';
  var titleLineLimit = cardSettings.pcard_title_line_limit ? " text-limit-".concat(cardSettings.pcard_title_line_limit) : '';
  var showAtcBelow = cardSettings.pcard_show_atc_below_price !== false;
  var buttonStyle = (_cardSettings$pcard_b = cardSettings.pcard_button_style) !== null && _cardSettings$pcard_b !== void 0 ? _cardSettings$pcard_b : 'btn--secondary';
  var v = (_ref2 = (_product$first_varian = product.first_variant) !== null && _product$first_varian !== void 0 ? _product$first_varian : (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants[0]) !== null && _ref2 !== void 0 ? _ref2 : {};
  var featuredImage = (_product$images = product.images) === null || _product$images === void 0 ? void 0 : _product$images[0];
  var secondImage = (_product$images2 = product.images) === null || _product$images2 === void 0 ? void 0 : _product$images2[1];
  var showSecondImg = cardSettings.pcard_show_second_img && (secondImage === null || secondImage === void 0 ? void 0 : secondImage.url);
  var priceRange = (_product$priceRange = product.priceRange) !== null && _product$priceRange !== void 0 ? _product$priceRange : {};

  // Prices are in cents (from normalization)
  var priceMinCents = (_priceRange$min = priceRange.min) !== null && _priceRange$min !== void 0 ? _priceRange$min : 0;
  var priceMaxCents = (_priceRange$max = priceRange.max) !== null && _priceRange$max !== void 0 ? _priceRange$max : priceMinCents;
  var priceMin = priceMinCents != null ? Number(priceMinCents) : undefined;
  var priceVaries = priceMinCents != null && priceMaxCents != null && Number(priceMaxCents) > Number(priceMinCents);
  var modelNumber = (_product$model_number = product.model_number) !== null && _product$model_number !== void 0 ? _product$model_number : v.sku;

  // Variant prices are in cents (from normalization)
  var variantPriceCents = v.price != null ? Number(v.price) : null;
  var priceCents = product.price != null ? Number(product.price) : variantPriceCents != null ? variantPriceCents : priceMinCents != null ? Number(priceMinCents) : 0;
  var compareAtCents = v.compareAtPrice != null ? Number(v.compareAtPrice) : 0;
  var onSale = compareAtCents > priceCents && priceCents > 0;
  var discountPct = (0,_api__WEBPACK_IMPORTED_MODULE_3__.parseDiscountPercentage)((_product$metafields = product.metafields) === null || _product$metafields === void 0 || (_product$metafields = _product$metafields.custom) === null || _product$metafields === void 0 ? void 0 : _product$metafields.discount);
  var hasDiscountPercentage = product.hasApplicablePrice === true || discountPct > 0;
  var available = ((_v$available = v.available) !== null && _v$available !== void 0 ? _v$available : product.available) !== false;
  var productPriceCents = Number(priceCents);
  var showAffirm = productPriceCents >= 100000 && productPriceCents <= 2000000;
  var showAcima = productPriceCents >= 30000 && productPriceCents <= 600000;
  var addOnsCount = metafieldListCount((_product$metafields2 = product.metafields) === null || _product$metafields2 === void 0 || (_product$metafields2 = _product$metafields2.custom) === null || _product$metafields2 === void 0 ? void 0 : _product$metafields2.add_ons);
  var mandatoryCount = metafieldListCount((_product$metafields3 = product.metafields) === null || _product$metafields3 === void 0 || (_product$metafields3 = _product$metafields3.custom) === null || _product$metafields3 === void 0 ? void 0 : _product$metafields3.mandatory_products);
  var surchargeCount = metafieldListCount((_product$metafields4 = product.metafields) === null || _product$metafields4 === void 0 || (_product$metafields4 = _product$metafields4.custom) === null || _product$metafields4 === void 0 ? void 0 : _product$metafields4.surcharge_for_california_in_percentage);
  var customisable = addOnsCount > 0 || mandatoryCount > 0 || surchargeCount > 0;
  var multiVariant = ((_product$variants$len = (_product$variants2 = product.variants) === null || _product$variants2 === void 0 ? void 0 : _product$variants2.length) !== null && _product$variants$len !== void 0 ? _product$variants$len : 0) > 1;
  var imageRatio = 1;
  var vendorHref = collectionFilterUrl('/collections/vendors', product.vendor);
  var typeHref = collectionFilterUrl('/collections/types', product.productType);

  // Compare checkbox - use web component (same as Liquid version)
  // Use enable_compare from settings instead of cardSettings
  var enableCompare = cardSettings.enable_compare !== false;
  var compareCheckboxId = "CompareCheckbox-".concat(product.id);
  var affirmElRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  // Init Affirm on mount so declarative .affirm-as-low-as is picked up (handles dynamic/React cards and third-party cookie delay).
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (!showAffirm) return;
    scheduleAffirmRefresh();
  }, [showAffirm]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card product-card-style-".concat(style).concat(style === 'card' ? " color-".concat(colorScheme) : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__wrapper h-full tw-flex tw-flex-col"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__image-wrapper".concat(!showSecondImg ? ' product-card__image-wrapper--main-only' : '', " color-").concat(overlayScheme, " bg-none")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({}, !isAddOn && {
    href
  }, {
    "aria-label": product.title,
    tabIndex: -1,
    className: "reversed-link"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "block",
    "data-motion": "zoom-out-sm"
  }, featuredImage !== null && featuredImage !== void 0 && featuredImage.url ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "media-wrapper product-card__image product-card__image--main",
    style: {
      '--aspect-ratio': imageRatio
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: featuredImage.url,
    alt: (_ref3 = (_featuredImage$alt = featuredImage.alt) !== null && _featuredImage$alt !== void 0 ? _featuredImage$alt : product.title) !== null && _ref3 !== void 0 ? _ref3 : '',
    className: "motion-reduce !tw-object-contain tw-bg-white tw-p-2",
    loading: "lazy",
    width: 600,
    height: Math.round(600 / imageRatio)
  })), showSecondImg && (secondImage === null || secondImage === void 0 ? void 0 : secondImage.url) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "media-wrapper product-card__image product-card__image--second inset-full hidden md:block",
    style: {
      '--aspect-ratio': imageRatio
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: secondImage.url,
    alt: (_ref4 = (_secondImage$alt = secondImage.alt) !== null && _secondImage$alt !== void 0 ? _secondImage$alt : product.title) !== null && _ref4 !== void 0 ? _ref4 : '',
    className: "motion-reduce !tw-object-contain tw-bg-white tw-p-2",
    loading: "lazy"
  }))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__image product-card__image--main",
    style: {
      '--aspect-ratio': 1
    }
  }, cardSettings.placeholder_image_url && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: cardSettings.placeholder_image_url,
    alt: "",
    className: "motion-reduce placeholder-image",
    loading: "lazy"
  })))), (!available && showSoldOutBadge || onSale && available && showSaleBadge) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__badge"
  }, !available && showSoldOutBadge && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "f-badge f-badge--soldout",
    "aria-hidden": "true"
  }, "Sold out"), onSale && available && showSaleBadge && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "f-badge f-badge--sale",
    "aria-hidden": "true"
  }, "Sale")), enableCompare && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("compare-checkbox", {
    class: "product-card__compare",
    "data-react": true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("label", {
    "data-tooltip": "left",
    className: "flex items-center justify-center cursor-pointer",
    htmlFor: compareCheckboxId
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    id: compareCheckboxId,
    className: "js-compare-checkbox",
    type: "checkbox",
    name: "product-compare",
    "data-product-id": product.id,
    "data-product-url": href
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tooltip pointer-events-none"
  }, "Compare")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__info tw-flex tw-flex-col tw-flex-1 text-".concat(contentAlign)
  }, showVendor && product.vendor && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "product-card__vendor text-sm-extra m-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: vendorHref,
    className: "reversed-link"
  }, product.vendor)), showType && product.productType && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "product-card__type text-sm-extra m-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: typeHref,
    className: "reversed-link"
  }, product.productType)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h3", {
    className: "product-card__title text-pcard-title"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    className: "reversed-link block".concat(titleLineLimit)
  }, !isAddOn && {
    href
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "reversed-link__text"
  }, product.title))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__bottom tw-flex tw-flex-col tw-flex-1 tw-gap-2"
  }, modelNumber && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "product-card__sku m-0 tw-text-[15px] tw-break-words tw-break-all"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("strong", null, "Model:"), " ", modelNumber), showPrice && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "f-price f-price--".concat(contentAlign).concat(!available ? ' f-price--sold-out' : '').concat(onSale ? ' f-price--on-sale' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "f-price__regular"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "visually-hidden visually-hidden--inline"
  }, "Regular price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "f-price-item f-price-item--regular"
  }, priceVaries && priceMin != null ? "From ".concat(formatPrice(priceMin)) : formatPrice(priceCents))), onSale && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "f-price__sale"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "visually-hidden"
  }, "Sale price"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "f-price-item f-price-item--sale"
  }, hasDiscountPercentage ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("s", null, formatPrice(compareAtCents)) : formatPrice(priceCents)), !hasDiscountPercentage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("s", {
    className: "f-price-item f-price-item--compare"
  }, formatPrice(compareAtCents))), hasDiscountPercentage && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "view-options-to-check-lowest-price tw-text-[11px] tw-leading-5 tw-block tw-text-[#D32F2F] tw-pt-1"
  }, "View options to check lowest price"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__actions-block tw-mt-auto tw-flex tw-flex-col tw-gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "finance-options-row tw-flex tw-flex-col tw-gap-2 tw-mb-[10px]"
  }, !isAddOn && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: href
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    ref: affirmElRef,
    id: showAffirm ? "affirm-card-".concat(product.id) : undefined,
    className: "product-card__affirm affirm-as-low-as tw-min-h-[54px] tw-text-[10px] md:tw-text-[14px] text-sm".concat(showAffirm ? ' tw-block' : ' tw-hidden'),
    "data-page-type": "category",
    "data-amount": productPriceCents,
    style: {
      backgroundColor: '#F4F6F8',
      padding: '5px',
      borderRadius: '8px'
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "acima-banner".concat(showAcima ? ' tw-block' : ' tw-hidden')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: href
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0727/0416/4007/files/acima-banner-final.png?v=1770888579",
    alt: "Lease to Own with Acima",
    loading: "lazy"
  }))))), cardSettings.pcard_show_cart_button && showAtcBelow && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__atc-below"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    href: isAddOn ? undefined : (multiVariant || customisable || !multiVariant && available && !customisable) && v.id != null ? '#' : href,
    className: "btn ".concat(buttonStyle, " btn--white-product-card w-full").concat(!available ? ' btn--disabled' : ''),
    "aria-disabled": !available
  }, !available && {
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    }
    // href: '#',
  }, (multiVariant || customisable) && !isAddOn && v.id != null && {
    'data-customise-trigger': true,
    'data-product-handle': product.handle,
    'data-variant-id': String(v.id)
  }, !multiVariant && available && !customisable && !isAddOn && v.id != null && {
    'data-variant-id': String(v.id),
    onClick: e => {
      e.preventDefault();
      (0,_product_customise__WEBPACK_IMPORTED_MODULE_2__.quickAddToCart)(e.currentTarget);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "loading__spinner hidden tw-absolute",
    "aria-hidden": "true"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    className: "spinner icon icon--extra-medium",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
    className: "path",
    fill: "none",
    strokeWidth: "4",
    cx: "33",
    cy: "33",
    r: "30"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "btn__text flex gap-1 items-center justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", null, multiVariant ? customisable ? 'View options' : 'Choose options' : available ? customisable ? customisable ? 'View options' : 'Choose options' : customisable ? 'View options' : 'Add to cart' : 'Sold out'))))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "product-card__list-actions hidden gap-3 flex-col"
  }, !isAddOn && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
    href: href,
    className: "btn btn--secondary"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "btn__text flex gap-1 items-center"
  }, "View details")))));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/SortBy.js"
/*!***************************************************************!*\
  !*** ./js/components/react/collection-product-grid/SortBy.js ***!
  \***************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SortBy)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function IconCaretDown() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    className: "icon icon-caret-down icon--2xs",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M16.25 7.5L10 13.75L3.75 7.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function SortBy(_ref) {
  var {
    sortBy,
    sortOptions = [],
    onChange: _onChange,
    enable_sorting = true,
    wrapperClassName
  } = _ref;
  if (!enable_sorting || sortOptions.length === 0) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: wrapperClassName !== null && wrapperClassName !== void 0 ? wrapperClassName : 'hidden no-js-hidden lg:flex items-center gap-2',
    id: "SortByContainer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
    htmlFor: "SortBy-collection",
    className: "text-nowrap font-body-bolder"
  }, "Sort by:"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "select w-auto facet-short flex items-center gap-2 flex-grow"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("select", {
    id: "SortBy-collection",
    className: "form-control form-control--select",
    value: sortBy,
    onChange: e => _onChange(e.target.value),
    "aria-describedby": "a11y-refresh-page-message"
  }, sortOptions.map(opt => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("option", {
    key: opt.value,
    value: opt.value
  }, opt.name))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(IconCaretDown, null)));
}

/***/ },

/***/ "./js/components/react/collection-product-grid/filterUtils.js"
/*!********************************************************************!*\
  !*** ./js/components/react/collection-product-grid/filterUtils.js ***!
  \********************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   filterProducts: () => (/* binding */ filterProducts),
/* harmony export */   getDisplayChips: () => (/* binding */ getDisplayChips),
/* harmony export */   getPriceRangeFromActiveFilters: () => (/* binding */ getPriceRangeFromActiveFilters),
/* harmony export */   normalizeFilter: () => (/* binding */ normalizeFilter),
/* harmony export */   toggleFilterValue: () => (/* binding */ toggleFilterValue)
/* harmony export */ });
/* unused harmony exports isPriceFilter, formatPriceRange */
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");


var _excluded = ["value", "checked"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Normalize a filter from Liquid (Shopify filter or custom metafield filter) to a common shape.
 * Shopify: { param_name, label, type, values: [{ value, label, count, active, param_name }] }
 * Custom: may have filter_title, filter_values or similar.
 */

function decodeHtml(str) {
  if (!str || typeof str !== 'string') return str;
  var txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}
function normalizeFilter(filter, index) {
  if (!filter || typeof filter !== 'object') return null;
  var id = "filter-".concat(index);
  var label = decodeHtml(filter.name);
  var isNonIndexed = filter.isNonIndexed;
  var filterType = filter.filterType;
  var values = [];
  if (Array.isArray(filter.values)) {
    values = filter.values.map(v => ({
      value: decodeHtml(v.value),
      label: decodeHtml(v.name)
    }));
  }
  var type = filter.filterType;
  if (type === 'price') {
    var firstValue = filter.values && filter.values[0];
    return {
      id,
      label,
      type,
      filterType,
      minPrice: (firstValue === null || firstValue === void 0 ? void 0 : firstValue.min) != null ? Number(firstValue.min) : 0,
      maxPrice: (firstValue === null || firstValue === void 0 ? void 0 : firstValue.max) != null ? Number(firstValue.max) : null,
      rangeMax: (firstValue === null || firstValue === void 0 ? void 0 : firstValue.rangeMax) != null ? Number(firstValue.rangeMax) : null
    };
  }
  return {
    id,
    label,
    type,
    namespace: filter.namespace,
    key: filter.key,
    values,
    isNonIndexed,
    filterType
  };
}

/** Whether an active filter is a price range bound (gte/lte). */
function isPriceFilter(f) {
  return f && f.filterType === 'price' && (f.key === 'gte' || f.key === 'lte');
}

/** Extract current price range from active filters. Values in cents. */
function getPriceRangeFromActiveFilters(activeFilters) {
  if (!Array.isArray(activeFilters)) return null;
  var min = null;
  var max = null;
  activeFilters.forEach(f => {
    if (!isPriceFilter(f)) return;
    var val = Number(f.value);
    if (f.key === 'gte') min = val;
    if (f.key === 'lte') max = val;
  });
  if (min == null && max == null) return null;
  return {
    min,
    max
  };
}

/** Format price range for display (e.g. "$969 - $10,434"). Values in cents. */
function formatPriceRange(minCents, maxCents) {
  var fmt = n => {
    if (n == null || isNaN(n)) return '';
    var dollars = n / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(dollars);
  };
  var a = fmt(minCents);
  var b = fmt(maxCents);
  if (a && b) return "".concat(a, " - ").concat(b);
  if (a) return "".concat(a, "+");
  if (b) return "Up to ".concat(b);
  return '';
}

/**
 * Build display chips for ActiveFilterChips. Price gte+lte are merged into one "min - max" chip.
 * Each chip: { key, label, getNextFilters(currentActiveFilters) }.
 */
function getDisplayChips(activeFilters) {
  if (!Array.isArray(activeFilters) || activeFilters.length === 0) return [];
  var priceRange = getPriceRangeFromActiveFilters(activeFilters);
  var nonPrice = activeFilters.filter(f => !isPriceFilter(f));
  var chips = [];
  if (priceRange != null && (priceRange.min != null || priceRange.max != null)) {
    var label = formatPriceRange(priceRange.min, priceRange.max);
    if (label) {
      chips.push({
        key: 'price-range',
        label,
        getNextFilters: current => current.filter(f => !isPriceFilter(f))
      });
    }
  }
  nonPrice.forEach(f => {
    chips.push({
      key: "filter-".concat(f.namespace, "-").concat(f.key, "-").concat(String(f.value)),
      label: String(f.value),
      getNextFilters: current => current.filter(x => x !== f)
    });
  });
  return chips;
}

/**
 * Toggle a single filter value in the active list.
 * Returns new active filters array: add if checked, remove if unchecked.
 */
function toggleFilterValue(_ref) {
  var {
    activeFilters,
    singleFilter
  } = _ref;
  var {
      value,
      checked
    } = singleFilter,
    restOFTheFilterAttributes = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(singleFilter, _excluded);
  if (checked) {
    if (activeFilters.some(f => f.value === value)) return activeFilters;
    return [...activeFilters, _objectSpread({
      value
    }, restOFTheFilterAttributes)];
  }
  return activeFilters.filter(f => f.value !== value);
}

/**
 * Client-side filter products by active filters.
 * When any non-indexed filter is active, ALL filters (indexed and non-indexed) are applied client-side.
 * Handles:
 * - Metafield filters: product.metafields[namespace][key] === value
 * - Price filters: product.priceRange.min/max against filter values
 * - Standard Shopify filters: productType, vendor, tags, variant options
 * 
 * Logic:
 * - Filters with same namespace+key work as OR (product matches if it matches any value)
 * - Filters with different namespace+key work as AND (product must match all groups)
 * 
 * @param {Array} products - Array of product objects
 * @param {Array} activeFilters - Array of filter objects with { namespace, key, value, isNonIndexed }
 * @returns {Array} Filtered products
 */
function filterProducts(products, activeFilters) {
  if (!Array.isArray(products)) return [];
  if (!Array.isArray(activeFilters) || activeFilters.length === 0) return products;

  // Group filters by namespace + key (same namespace+key = OR condition)
  var filterGroups = {};
  activeFilters.forEach(f => {
    var namespace = f.namespace;
    var key = f.key;
    if (namespace && key && f.value != null) {
      var groupKey = "".concat(namespace, ".").concat(key);
      if (!filterGroups[groupKey]) {
        filterGroups[groupKey] = [];
      }
      filterGroups[groupKey].push(f);
    }
  });

  // If no valid filter groups, return all products
  var groupKeys = Object.keys(filterGroups);
  if (groupKeys.length === 0) return products;
  return products.filter(product => {
    // Each group is an AND condition
    return groupKeys.every(groupKey => {
      var groupFilters = filterGroups[groupKey];
      // Within a group, filters work as OR (match any value)
      var groupMatches = groupFilters.some(f => {
        var namespace = f.namespace;
        var key = f.key;
        var val = f.value;

        // Price filter: check if key is 'gte' or 'lte' (price range filters)
        if (key === 'gte' || key === 'lte') {
          var _product$priceRange, _product$priceRange2;
          var priceMin = ((_product$priceRange = product.priceRange) === null || _product$priceRange === void 0 ? void 0 : _product$priceRange.min) != null ? Number(product.priceRange.min) : 0;
          var priceMax = ((_product$priceRange2 = product.priceRange) === null || _product$priceRange2 === void 0 ? void 0 : _product$priceRange2.max) != null ? Number(product.priceRange.max) : priceMin;
          var filterPrice = Number(val);
          if (key === 'gte') {
            // Price must be >= filter value (check min price)
            return priceMin >= filterPrice;
          }
          if (key === 'lte') {
            // Price must be <= filter value (check max price)
            return priceMax <= filterPrice;
          }
          return false;
        }
        // Metafield filter: product.metafields[namespace][key] === value
        // For all other cases, check as metafield
        if (namespace && key) {
          if (product.metafields && product.metafields[namespace]) {
            var metafieldValue = product.metafields[namespace][key];
            if (metafieldValue != null) {
              // List metafields (e.g. list.single_line_text_field) come through as JS arrays
              if (Array.isArray(metafieldValue)) {
                return metafieldValue.some(v => String(v).toLowerCase() === String(val).toLowerCase());
              }
              // JSON-encoded array strings, just in case
              if (typeof metafieldValue === 'string' && metafieldValue.startsWith('[')) {
                try {
                  var parsed = JSON.parse(metafieldValue);
                  if (Array.isArray(parsed)) {
                    return parsed.some(v => String(v).toLowerCase() === String(val).toLowerCase());
                  }
                } catch (e) {/* fall through to string comparison */}
              }
              // Scalar value: case-insensitive string comparison
              return String(metafieldValue).toLowerCase() === String(val).toLowerCase();
            }
          }
          // If metafield doesn't exist, exclude the product
          return false;
        }

        // Unknown filter type without namespace/key, exclude product
        return false;
      });
      return groupMatches;
    });
  });
}

/***/ },

/***/ "./js/components/react/collection-product-grid/index.js"
/*!**************************************************************!*\
  !*** ./js/components/react/collection-product-grid/index.js ***!
  \**************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CollectionProductGridWrapper)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CollectionProductGrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CollectionProductGrid */ "./js/components/react/collection-product-grid/CollectionProductGrid.js");



/**
 * Collection product grid (React) — entry component.
 * Receives initial state from Liquid via shopifyData.
 */
function CollectionProductGridWrapper(_ref) {
  var {
    shopifyData = {}
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_CollectionProductGrid__WEBPACK_IMPORTED_MODULE_1__["default"], shopifyData);
}

/***/ },

/***/ "./js/components/react/collection-product-grid/paginate.js"
/*!*****************************************************************!*\
  !*** ./js/components/react/collection-product-grid/paginate.js ***!
  \*****************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LoadMoreButton: () => (/* binding */ LoadMoreButton),
/* harmony export */   useLoadMoreState: () => (/* binding */ useLoadMoreState)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);



/**
 * Load-more pagination state: client-side vs server-side by non-indexed filters.
 * - Server-side: any non-indexed filter is active → we must paginate via API with cursor (after).
 * - Client-side: no non-indexed filters → we can paginate from in-memory list or still use API cursor sequentially.
 * Both modes use sequential cursor-based "load more" (first page, then after endCursor, etc.).
 *
 * @param {{ hasNonIndexedFilters: boolean }} options
 * @returns {{
 *   paginationMode: 'client' | 'server',
 *   endCursor: string | null,
 *   hasNextPage: boolean,
 *   loading: boolean,
 *   setPageInfo: (pageInfo: { endCursor?: string | null; hasNextPage?: boolean }) => void,
 *   loadMore: (fetchNextPage: () => Promise<{ products: unknown[]; pageInfo: { endCursor?: string | null; hasNextPage?: boolean } }>) => Promise<void>,
 *   appendProducts: (nextProducts: unknown[]) => void,
 *   reset: () => void
 * }}
 */
function useLoadMoreState(_ref) {
  var {
    hasNonIndexedFilters
  } = _ref;
  var [endCursor, setEndCursor] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  var [hasNextPage, setHasNextPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var paginationMode = hasNonIndexedFilters ? 'server' : 'client';
  var setPageInfo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(pageInfo => {
    var _pageInfo$endCursor;
    if (pageInfo == null) return;
    if (pageInfo.endCursor !== undefined) setEndCursor((_pageInfo$endCursor = pageInfo.endCursor) !== null && _pageInfo$endCursor !== void 0 ? _pageInfo$endCursor : null);
    if (pageInfo.hasNextPage !== undefined) setHasNextPage(Boolean(pageInfo.hasNextPage));
  }, []);
  var appendProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {}); // no-op here; parent appends to their products state

  var loadMore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (fetchNextPage) {
      setLoading(true);
      try {
        var result = yield fetchNextPage();
        if (result !== null && result !== void 0 && result.pageInfo) setPageInfo(result.pageInfo);
        return result;
      } finally {
        setLoading(false);
      }
    });
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setPageInfo]);
  var reset = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    setEndCursor(null);
    setHasNextPage(false);
    setLoading(false);
  }, []);
  return {
    paginationMode,
    endCursor,
    hasNextPage,
    loading,
    setPageInfo,
    loadMore,
    appendProducts,
    reset
  };
}
function LoadMoreButton(_ref3) {
  var {
    onClick,
    loading = false,
    hasNextPage = false,
    paginationMode = 'server',
    paginationType = 'load_more'
  } = _ref3;
  if (paginationType !== 'load_more' || !hasNextPage) {
    return null;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "collection__load-more tw-mt-12 tw-flex tw-justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    type: "button",
    className: "btn btn--secondary",
    onClick: onClick,
    disabled: loading,
    "aria-busy": loading,
    "data-pagination-mode": paginationMode
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "btn__text"
  }, loading ? 'Loading…' : 'Load more')));
}

/***/ },

/***/ "./js/sections/main-collection-product-grid-react.js"
/*!***********************************************************!*\
  !*** ./js/sections/main-collection-product-grid-react.js ***!
  \***********************************************************/
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var JsComponents_react_collection_product_grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/react/collection-product-grid */ "./js/components/react/collection-product-grid/index.js");


(function initCollectionProductGridReact() {
  var container = '[data-collection-product-grid-root]';
  var propsEl = '#collection-product-grid-props';
  if (!document.querySelector(container)) return;
  // Disable browser automatic scroll restoration
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(JsComponents_react_collection_product_grid__WEBPACK_IMPORTED_MODULE_1__["default"], container, propsEl);
})();

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; (typeof current == 'object' || typeof current == 'function') && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"main-collection-product-grid-react": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/main-collection-product-grid-react.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;